// // // // // // // after the Notes flag change on 12/09/2025

// // // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock } from "lucide-react";
// // // // // // import LeadDetails from "./Leaddetails";
// // // // // // import TimelineComponent from "./Header";
// // // // // // import Reports from "./Reports";

// // // // // // const allColumns = [
// // // // // //   { key: "Sales_Agent", label: "Sales Agent" },
// // // // // //   { key: "Customer_Name", label: "Lead Name" },
// // // // // //   { key: "Move_Date", label: "Move Date" },
// // // // // //   { key: "Status", label: "Estimate Status" },
// // // // // //   { key: "OriginCity", label: "From Province" },
// // // // // //   { key: "DestinationCity", label: "To Province" },
// // // // // //   { key: "FollowUpDate", label: "Follow Up Date" },
// // // // // //   { key: "Move_Size", label: "Move Size" },
// // // // // //   { key: "Lead_Status", label: "Lead Status" },
// // // // // //   { key: "Move_Type", label: "Move Type" },
// // // // // //   { key: "Estimate_Amount", label: "Estimate Amount" },
// // // // // //   { key: "From_Postcode", label: "From Postcode" },
// // // // // //   { key: "To_Postcode", label: "To Postcode" },
// // // // // //   { key: "Received_Date_EST", label: "Received Date EST" },
// // // // // //   { key: "Banner", label: "Banner" },
// // // // // //   { key: "Lead_Priority", label: "Lead Priority" },
// // // // // //   { key: "Received_Time_IST", label: "Received Time IST" },
// // // // // // ];

// // // // // // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// // // // // //   const [showReports, setShowReports] = useState(false);
// // // // // //   const [data, setData] = useState([]);
// // // // // //   const [filteredData, setFilteredData] = useState([]);
// // // // // //   const [searchQuery, setSearchQuery] = useState("");
// // // // // //   const [loading, setLoading] = useState(true);
// // // // // //   const [error, setError] = useState(null);
// // // // // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // // // // //   const [width, setWidth] = useState(350);
// // // // // //   const [showFilter, setShowFilter] = useState(false);
// // // // // //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// // // // // //   const [columnFilters, setColumnFilters] = useState({});
// // // // // //   const [selectedColumns, setSelectedColumns] = useState(
// // // // // //     allColumns.slice(0, 7).map((col) => col.key)
// // // // // //   );
// // // // // //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// // // // // //   const filterRef = useRef(null);
// // // // // //   const isResizing = useRef(false);
// // // // // //   const [userMap, setUserMap] = useState({});
// // // // // //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// // // // // //   const prevSelectedLeadId = useRef(null);
// // // // // //   const [allNotes, setAllNotes] = useState([]);

// // // // // //   const updateLeadData = (updatedBooking) => {
// // // // // //     setData((prevData) =>
// // // // // //       prevData.map((lead) =>
// // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // //           ? { ...lead, ...updatedBooking }
// // // // // //           : lead
// // // // // //       )
// // // // // //     );
// // // // // //     setFilteredData((prevFilteredData) =>
// // // // // //       prevFilteredData.map((lead) =>
// // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // //           ? { ...lead, ...updatedBooking }
// // // // // //           : lead
// // // // // //       )
// // // // // //     );
// // // // // //     if (
// // // // // //       selectedBooking &&
// // // // // //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // //     ) {
// // // // // //       setSelectedBooking(updatedBooking);
// // // // // //     }
// // // // // //   };

// // // // // //   const refetchNotes = () => {
// // // // // //     fetchAllNotes();
// // // // // //   };

// // // // // //   const formatFollowUpDate = (date) => {
// // // // // //     if (!date) return "N/A";
// // // // // //     return date.replace("T", " ");
// // // // // //   };

// // // // // //   const handleDefaultSort = () => {
// // // // // //     setSearchQuery("");
// // // // // //     setColumnFilters({});
// // // // // //     setIsGlobalSearch(false);
// // // // // //     setIsDefaultSort(true);
// // // // // //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // //     fetchLeads();
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     const fetchUserData = async () => {
// // // // // //       try {
// // // // // //         const response = await fetch(
// // // // // //           "https://salesjet-10097049716.catalystappsail.com/userdata",
// // // // // //           {
// // // // // //             method: "GET",
// // // // // //             headers: {
// // // // // //               Authorization: `Bearer ${accessToken}`,
// // // // // //               "Content-Type": "application/json",
// // // // // //             },
// // // // // //           }
// // // // // //         );
// // // // // //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //         const result = await response.json();
// // // // // //         const userMapping = result.data.reduce((acc, user) => {
// // // // // //           acc[user.userId] = user.pseudoname;
// // // // // //           return acc;
// // // // // //         }, {});
// // // // // //         setUserMap(userMapping);
// // // // // //       } catch (err) {
// // // // // //         console.error("Error fetching user data:", err.message);
// // // // // //       }
// // // // // //     };
// // // // // //     fetchUserData();
// // // // // //   }, [accessToken]);

// // // // // //   const fetchLeads = async () => {
// // // // // //     try {
// // // // // //       setLoading(true);
// // // // // //       const response = await fetch(
// // // // // //         "https://salesjet-10097049716.catalystappsail.com/leadsdata",
// // // // // //         {
// // // // // //           method: "GET",
// // // // // //           headers: {
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //             "Content-Type": "application/json",
// // // // // //           },
// // // // // //         }
// // // // // //       );
// // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //       const result = await response.json();
// // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // //       setData(leads);
// // // // // //       setFilteredData(leads);
// // // // // //     } catch (err) {
// // // // // //       setError(err.message);
// // // // // //     } finally {
// // // // // //       setLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   const fetchAllNotes = async () => {
// // // // // //     try {
// // // // // //       const response = await fetch(
// // // // // //         "https://salesjet-10097049716.catalystappsail.com/allleadnotes",
// // // // // //         {
// // // // // //           method: "GET",
// // // // // //           headers: {
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //             "Content-Type": "application/json",
// // // // // //           },
// // // // // //         }
// // // // // //       );
// // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //       const result = await response.json();
// // // // // //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// // // // // //     } catch (err) {
// // // // // //       console.error("Error fetching all lead notes:", err.message);
// // // // // //     }
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     if (!isGlobalSearch) {
// // // // // //       fetchLeads();
// // // // // //       fetchAllNotes();
// // // // // //     }
// // // // // //   }, [accessToken, isGlobalSearch]);

// // // // // //   // Apply default sort on component mount
// // // // // //   useEffect(() => {
// // // // // //     handleDefaultSort();
// // // // // //   }, []);

// // // // // //   useEffect(() => {
// // // // // //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// // // // // //       prevSelectedLeadId.current = selectedLeadId;
// // // // // //       setIsGlobalSearch(true);
// // // // // //       setColumnFilters({});
// // // // // //       handleGlobalSearch(selectedLeadId.toString());
// // // // // //     }
// // // // // //   }, [selectedLeadId]);

// // // // // //   useEffect(() => {
// // // // // //     if (selectedLeadId && filteredData.length > 0) {
// // // // // //       const matchingLead = filteredData.find(
// // // // // //         (lead) =>
// // // // // //           lead.LeadACVLRecordID &&
// // // // // //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// // // // // //       );
// // // // // //       if (matchingLead) {
// // // // // //         setSelectedBooking(matchingLead);
// // // // // //         setWidth(700);
// // // // // //       } else {
// // // // // //         setSelectedBooking(null);
// // // // // //       }
// // // // // //     } else if (selectedLeadId && filteredData.length === 0) {
// // // // // //       setSelectedBooking(null);
// // // // // //     }
// // // // // //   }, [filteredData, selectedLeadId]);

// // // // // //   useEffect(() => {
// // // // // //     let filtered = [...data];
// // // // // //     if (searchQuery.trim()) {
// // // // // //       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //       filtered = filtered.filter((lead) =>
// // // // // //         Object.entries(lead).some(([key, value]) => {
// // // // // //           if (!value) return false;
// // // // // //           const normalizedValue = value
// // // // // //             .toString()
// // // // // //             .replace(/[^a-zA-Z0-9]/g, "")
// // // // // //             .toLowerCase();
// // // // // //           return normalizedValue.includes(normalizedQuery);
// // // // // //         })
// // // // // //       );
// // // // // //     }
// // // // // //     Object.keys(columnFilters).forEach((key) => {
// // // // // //       const filterValue = columnFilters[key]?.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //       if (filterValue) {
// // // // // //         filtered = filtered.filter((lead) => {
// // // // // //           const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //           return value?.includes(filterValue);
// // // // // //         });
// // // // // //       }
// // // // // //     });
// // // // // //     setFilteredData(filtered);
// // // // // //   }, [data, searchQuery, columnFilters]);

// // // // // //   const handleSearchChange = (query) => {
// // // // // //     setSearchQuery(query);
// // // // // //     setIsGlobalSearch(false);
// // // // // //     setColumnFilters({});
// // // // // //   };

// // // // // //   const handleGlobalSearch = async (query) => {
// // // // // //     setLoading(true);
// // // // // //     setIsDefaultSort(false);
// // // // // //     setIsGlobalSearch(true);
// // // // // //     try {
// // // // // //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // //       const response = await fetch(
// // // // // //         "https://salesjet-10097049716.catalystappsail.com/globalsearch",
// // // // // //         {
// // // // // //           method: "POST",
// // // // // //           headers: {
// // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // //             "Content-Type": "application/json",
// // // // // //           },
// // // // // //           body: JSON.stringify({ query: normalizedQuery }),
// // // // // //         }
// // // // // //       );
// // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // //       const result = await response.json();
// // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // //       setFilteredData(leads);
// // // // // //       setSearchQuery(query);
// // // // // //       fetchAllNotes();
// // // // // //     } catch (err) {
// // // // // //       setError(err.message);
// // // // // //     } finally {
// // // // // //       setLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   const handleSort = (key) => {
// // // // // //     setIsDefaultSort(false);
// // // // // //     setSortConfig((prev) =>
// // // // // //       prev.key === key
// // // // // //         ? {
// // // // // //             key,
// // // // // //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// // // // // //           }
// // // // // //         : { key, direction: "ascending" }
// // // // // //     );
// // // // // //   };

// // // // // //   const sortedData = React.useMemo(() => {
// // // // // //     let sortableData = [...filteredData];
// // // // // //     if (isDefaultSort) {
// // // // // //       // Get current date in EST (America/Toronto)
// // // // // //       const now = new Date();
// // // // // //       const todayStr = now.toLocaleString('en-CA', { 
// // // // // //         timeZone: 'America/Toronto', 
// // // // // //         year: 'numeric', 
// // // // // //         month: '2-digit', 
// // // // // //         day: '2-digit' 
// // // // // //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// // // // // //       // Custom sorting logic
// // // // // //       sortableData.sort((a, b) => {
// // // // // //         const isUnassignedA = a.Status === null || a.Status === undefined;
// // // // // //         const isUnassignedB = b.Status === null || b.Status === undefined;
// // // // // //         const timeA = a.Received_Date_EST;
// // // // // //         const timeB = b.Received_Date_EST;
// // // // // //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// // // // // //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// // // // // //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// // // // // //         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
// // // // // //           return -1;
// // // // // //         }
// // // // // //         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
// // // // // //           return 1;
// // // // // //         }

// // // // // //         // Step 2: Leads with FollowUpDate date as today (EST)
// // // // // //         if (followUpA === todayStr && followUpB !== todayStr) return -1;
// // // // // //         if (followUpB === todayStr && followUpA !== todayStr) return 1;

// // // // // //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// // // // // //         const idA = Number(a.LeadACVLRecordID || 0);
// // // // // //         const idB = Number(b.LeadACVLRecordID || 0);
// // // // // //         return idB - idA;
// // // // // //       });
// // // // // //     } else if (sortConfig.key) {
// // // // // //       sortableData.sort((a, b) => {
// // // // // //         let aVal = a[sortConfig.key];
// // // // // //         let bVal = b[sortConfig.key];
// // // // // //         // Handle null or undefined values
// // // // // //         if (aVal === undefined || aVal === null) return 1;
// // // // // //         if (bVal === undefined || bVal === null) return -1;
// // // // // //         // Handle LeadACVLRecordID specifically as a number
// // // // // //         if (sortConfig.key === "LeadACVLRecordID") {
// // // // // //           aVal = Number(aVal);
// // // // // //           bVal = Number(bVal);
// // // // // //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // //         }
// // // // // //         // Handle date fields
// // // // // //         const isDateField = [
// // // // // //           "Move_Date",
// // // // // //           "Received_Date_EST",
// // // // // //           "Received_Time_IST",
// // // // // //           "FollowUpDate",
// // // // // //         ].includes(sortConfig.key);
// // // // // //         if (isDateField) {
// // // // // //           const dateA = new Date(aVal);
// // // // // //           const dateB = new Date(bVal);
// // // // // //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// // // // // //         }
// // // // // //         // Handle string fields
// // // // // //         if (typeof aVal === "string" && typeof bVal === "string") {
// // // // // //           return sortConfig.direction === "ascending"
// // // // // //             ? aVal.localeCompare(bVal)
// // // // // //             : bVal.localeCompare(bVal);
// // // // // //         }
// // // // // //         // Handle numeric fields
// // // // // //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // //       });
// // // // // //     }
// // // // // //     return sortableData;
// // // // // //   }, [filteredData, sortConfig, isDefaultSort]);

// // // // // //   const notesByLead = React.useMemo(() => {
// // // // // //     const map = {};
// // // // // //     allNotes.forEach((note) => {
// // // // // //       const id = note.LeadACVLRecordID;
// // // // // //       if (id) {
// // // // // //         if (!map[id]) {
// // // // // //           map[id] = { notes: [], latestByCategory: {} };
// // // // // //         }
// // // // // //         map[id].notes.push(note);
// // // // // //       }
// // // // // //     });
// // // // // //     Object.keys(map).forEach((leadId) => {
// // // // // //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// // // // // //       const categoryMap = {};
// // // // // //       map[leadId].notes.forEach((note) => {
// // // // // //         const category = note.Category?.toLowerCase() || "";
// // // // // //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// // // // // //           categoryMap[category] = note;
// // // // // //         }
// // // // // //       });
// // // // // //       map[leadId].latestByCategory = categoryMap;
// // // // // //     });
// // // // // //     return map;
// // // // // //   }, [allNotes]);

// // // // // //   const startResizing = (e) => {
// // // // // //     isResizing.current = true;
// // // // // //     document.addEventListener("mousemove", resize);
// // // // // //     document.addEventListener("mouseup", stopResizing);
// // // // // //   };

// // // // // //   const resize = (e) => {
// // // // // //     if (!isResizing.current) return;
// // // // // //     const minWidth = 500;
// // // // // //     const maxWidth = window.innerWidth * 0.7;
// // // // // //     let newWidth = window.innerWidth - e.clientX;
// // // // // //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// // // // // //       setWidth(newWidth);
// // // // // //     }
// // // // // //   };

// // // // // //   const stopResizing = () => {
// // // // // //     isResizing.current = false;
// // // // // //     document.removeEventListener("mousemove", resize);
// // // // // //     document.removeEventListener("mouseup", stopResizing);
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     const handleClickOutside = (event) => {
// // // // // //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// // // // // //         setShowFilter(false);
// // // // // //       }
// // // // // //     };
// // // // // //     document.addEventListener("mousedown", handleClickOutside);
// // // // // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // // // // //   }, []);

// // // // // //   const handleColumnChange = (event) => {
// // // // // //     const value = event.target.value;
// // // // // //     setSelectedColumns((prev) =>
// // // // // //       prev.includes(value)
// // // // // //         ? prev.filter((col) => col !== value)
// // // // // //         : prev.length < 7
// // // // // //         ? [...prev, value]
// // // // // //         : prev
// // // // // //     );
// // // // // //   };

// // // // // //   const today = new Date().toISOString().split('T')[0];

// // // // // //   return (
// // // // // //     <div>
// // // // // //       <>
// // // // // //         <TimelineComponent
// // // // // //           userDetails={userDetails}
// // // // // //           accessToken={accessToken}
// // // // // //           onSearchChange={handleSearchChange}
// // // // // //           onGlobalSearch={handleGlobalSearch}
// // // // // //           connectionStatus={connectionStatus}
// // // // // //           onShowReports={() => setShowReports(true)}
// // // // // //         />
// // // // // //       </>
// // // // // //       {showReports && (
// // // // // //         <>
// // // // // //           <button onClick={() => setShowReports(false)}>✖ Close Report</button>
// // // // // //           <Reports />
// // // // // //         </>
// // // // // //       )}
// // // // // //       {!showReports && (
// // // // // //         <div className="table-container">
// // // // // //           <div
// // // // // //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// // // // // //             style={{ flex: selectedBooking ? "1" : "2" }}
// // // // // //           >
// // // // // //             <div>
// // // // // //               <div className="bookings-header-my">
// // // // // //                 <span
// // // // // //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// // // // // //                   onClick={() => handleSort("LeadACVLRecordID")}
// // // // // //                   style={{ cursor: "pointer" }}
// // // // // //                 >
// // // // // //                   ACVL LeadID
// // // // // //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// // // // // //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // //                 </span>
// // // // // //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // //                   (colKey) => {
// // // // // //                     const column = allColumns.find((c) => c.key === colKey);
// // // // // //                     const isSorted = sortConfig.key === colKey;
// // // // // //                     return column ? (
// // // // // //                       <span
// // // // // //                         key={colKey}
// // // // // //                         className="sortable-header"
// // // // // //                         onClick={() => handleSort(colKey)}
// // // // // //                         style={{ cursor: "pointer" }}
// // // // // //                       >
// // // // // //                         {column.label}
// // // // // //                         {!isDefaultSort && isSorted &&
// // // // // //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // //                       </span>
// // // // // //                     ) : null;
// // // // // //                   }
// // // // // //                 )}
// // // // // //                 <span2>
// // // // // //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// // // // // //                     <div>
// // // // // //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// // // // // //                     </div>
// // // // // //                     <div>
// // // // // //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// // // // // //                     </div>
// // // // // //                     <div>
// // // // // //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// // // // // //                     </div>
// // // // // //                     <div>
// // // // // //                       <Search
// // // // // //                         className="filter-icon"
// // // // // //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// // // // // //                         title="Advanced column search"
// // // // // //                       />
// // // // // //                     </div>
// // // // // //                   </div>
// // // // // //                 </span2>
// // // // // //                 {showFilter && (
// // // // // //                   <div className="filter-dropdown" ref={filterRef}>
// // // // // //                     {allColumns.map((col) => (
// // // // // //                       <label key={col.key}>
// // // // // //                         <input
// // // // // //                           type="checkbox"
// // // // // //                           value={col.key}
// // // // // //                           checked={selectedColumns.includes(col.key)}
// // // // // //                           onChange={handleColumnChange}
// // // // // //                           disabled={
// // // // // //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// // // // // //                           }
// // // // // //                         />
// // // // // //                         {col.label}
// // // // // //                       </label>
// // // // // //                     ))}
// // // // // //                   </div>
// // // // // //                 )}
// // // // // //               </div>
// // // // // //               {showAdvancedFilter && (
// // // // // //                 <div className="column-filter-row">
// // // // // //                   <span className="filter-input">
// // // // // //                     <input
// // // // // //                       placeholder="Lead ID"
// // // // // //                       value={columnFilters["LeadACVLRecordID"] || ""}
// // // // // //                       onChange={(e) =>
// // // // // //                         setColumnFilters({
// // // // // //                           ...columnFilters,
// // // // // //                           LeadACVLRecordID: e.target.value,
// // // // // //                         })
// // // // // //                       }
// // // // // //                     />
// // // // // //                   </span>
// // // // // //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // //                     (colKey) => (
// // // // // //                       <span key={colKey} className="filter-input">
// // // // // //                         <input
// // // // // //                           placeholder={
// // // // // //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// // // // // //                           }
// // // // // //                           value={columnFilters[colKey] || ""}
// // // // // //                           onChange={(e) =>
// // // // // //                             setColumnFilters({
// // // // // //                               ...columnFilters,
// // // // // //                               [colKey]: e.target.value,
// // // // // //                             })
// // // // // //                           }
// // // // // //                         />
// // // // // //                       </span>
// // // // // //                     )
// // // // // //                   )}
// // // // // //                   <span className="filter-icons-space" />
// // // // // //                 </div>
// // // // // //               )}
// // // // // //               {loading && <p>Loading...</p>}
// // // // // //               {error && <p className="error">{error}</p>}
// // // // // //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// // // // // //               {!loading &&
// // // // // // !error &&
// // // // // // sortedData.map((item, index) => {
// // // // // //   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // // // // //   const categories = leadNotesData.latestByCategory;
// // // // // //   let flags = [];
// // // // // //   const now = new Date();
// // // // // //   const todayStr = now.toLocaleString('en-CA', { 
// // // // // //     timeZone: 'America/Toronto', 
// // // // // //     year: 'numeric', 
// // // // // //     month: '2-digit', 
// // // // // //     day: '2-digit' 
// // // // // //   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// // // // // //   const isUnassignedToday =
// // // // // //     (item.Status === null || item.Status === undefined) &&
// // // // // //     item.Received_Date_EST &&
// // // // // //     item.Received_Date_EST.split(' ')[0] === todayStr;
// // // // // //   const isUnassignedall =
// // // // // //     (item.Status === null || item.Status === undefined) &&
// // // // // //     item.Received_Date_EST &&
// // // // // //     item.Received_Date_EST.split(' ')[0] !== todayStr;
// // // // // //   let isTodayFollowUp = false;

// // // // // //   // Collect and process follow-up dates
// // // // // //   const followUpDates = [];
  
// // // // // //   // Add follow-up date from notes (next follow-up category)
// // // // // //   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // // // // //     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // //     if (noteDate) {
// // // // // //       followUpDates.push(noteDate);
// // // // // //     }
// // // // // //   }

// // // // // //   // Add follow-up date from item.FollowUpDate
// // // // // //   if (item.FollowUpDate) {
// // // // // //     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // //     if (itemDate && !followUpDates.includes(itemDate)) {
// // // // // //       followUpDates.push(itemDate);
// // // // // //     }
// // // // // //   }

// // // // // //   // Select the most relevant follow-up date
// // // // // //   let selectedFollowUpDate = null;
// // // // // //   if (followUpDates.length > 0) {
// // // // // //     // Prioritize: today's date, then past date, then future date
// // // // // //     const today = new Date(todayStr);
// // // // // //     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// // // // // //       const followUpDate = new Date(dateStr);
// // // // // //       if (!selected) return dateStr;
// // // // // //       const selectedDate = new Date(selected);
// // // // // //       if (dateStr === todayStr) return dateStr; // Prioritize today's date
// // // // // //       if (selected === todayStr) return selected;
// // // // // //       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// // // // // //       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// // // // // //       return selected; // Keep first date if no priority
// // // // // //     }, null);

// // // // // //     if (selectedFollowUpDate) {
// // // // // //       const followUpDate = new Date(selectedFollowUpDate);
// // // // // //       isTodayFollowUp = selectedFollowUpDate === todayStr;
// // // // // //       let color;
// // // // // //       if (followUpDate < today && !isTodayFollowUp) {
// // // // // //         color = "red"; // Past date
// // // // // //       } else if (isTodayFollowUp) {
// // // // // //         color = "green"; // Today
// // // // // //       } else {
// // // // // //         color = "gray"; // Future date
// // // // // //       }
// // // // // //       flags.push({ 
// // // // // //         icon: Clock, 
// // // // // //         color, 
// // // // // //         title: `Follow-Up: ${selectedFollowUpDate}` 
// // // // // //       });
// // // // // //     }
// // // // // //   }

// // // // // //   // Process other categories
// // // // // //   Object.values(categories).forEach((note) => {
// // // // // //     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// // // // // //       const category = note.Category?.toLowerCase() || "";
// // // // // //       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // // // // //       if (category === "connection status") {
// // // // // //         if (categoryDetails === "connected") {
// // // // // //           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // // // // //         } else if (categoryDetails === "not connected") {
// // // // // //           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // // // // //         }
// // // // // //       } else if (category === "prospective") {
// // // // // //         if (categoryDetails === "hot") {
// // // // // //           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // // // // //         } else if (categoryDetails === "warm") {
// // // // // //           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // // // // //         } else if (categoryDetails === "cold") {
// // // // // //           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // // // // //         }
// // // // // //       }
// // // // // //     }
// // // // // //   });

// // // // // //   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // // // // //   const orderedFlags = new Array(5).fill(null);
// // // // // //   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // // // // //     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // // // // //   }
// // // // // //   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // // // // //     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // // // // //       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // // // // //     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // // // // //       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // // // // //     } else {
// // // // // //       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // // // // //     }
// // // // // //   }
// // // // // //   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // // // // //   if (prospectiveFlag) {
// // // // // //     orderedFlags[2] = prospectiveFlag;
// // // // // //   }
// // // // // //   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // // // // //   if (connectionFlag) {
// // // // // //     orderedFlags[3] = connectionFlag;
// // // // // //   }
// // // // // //   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // // // // //   if (followUpFlag) {
// // // // // //     orderedFlags[4] = followUpFlag;
// // // // // //   }

// // // // // //   return (
// // // // // //     <div
// // // // // //       key={index}
// // // // // //       className={`booking-item-my ${
// // // // // //         selectedBooking === item ? "active-booking" : ""
// // // // // //       } ${
// // // // // //         item.Duplicate_Lead_Details &&
// // // // // //         Object.keys(item.Duplicate_Lead_Details).length > 0
// // // // // //           ? "duplicate-item"
// // // // // //           : ""
// // // // // //       } ${
// // // // // //         item.Lead_Source_Status?.toLowerCase() === "return"
// // // // // //           ? "returned-item"
// // // // // //           : ""
// // // // // //       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // // // // //       onClick={() => {
// // // // // //         if (!selectedBooking) setWidth(700);
// // // // // //         setSelectedBooking(item);
// // // // // //       }}
// // // // // //       style={{
// // // // // //         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // // // // //         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // // // // //         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // // // // //         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // // // // //       }}
// // // // // //     >
// // // // // //       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // // // // //       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // //         (colKey) => (
// // // // // //           <span1 key={colKey}>
// // // // // //             {colKey === "AssignedUserID"
// // // // // //               ? userMap[item.AssignedUserID] || "N/A"
// // // // // //               : colKey === "FollowUpDate"
// // // // // //               ? formatFollowUpDate(item[colKey])
// // // // // //               : item[colKey] || "N/A"}
// // // // // //           </span1>
// // // // // //         )
// // // // // //       )}
// // // // // //       <span2 style={{
// // // // // //         display: "flex",
// // // // // //         gap: "8px",
// // // // // //         alignItems: "center",
// // // // // //         justifyContent: "flex-end",
// // // // // //         width: "120px",
// // // // // //       }}>
// // // // // //         {orderedFlags.map((flag, idx) => (
// // // // // //           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // // // // //             {flag && (
// // // // // //               <>
// // // // // //                 <flag.icon
// // // // // //                   className="icon"
// // // // // //                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // // // // //                   title={flag.title}
// // // // // //                 />
// // // // // //                 <div className="custom-tooltip">
// // // // // //                   {flag.title}
// // // // // //                 </div>
// // // // // //               </>
// // // // // //             )}
// // // // // //           </div>
// // // // // //         ))}
// // // // // //       </span2>
// // // // // //     </div>
// // // // // //   );

// // // // // //                 // !error &&
// // // // // //                 // sortedData.map((item, index) => {
// // // // // //                 //   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // // // // //                 //   const categories = leadNotesData.latestByCategory;
// // // // // //                 //   let flags = [];
// // // // // //                 //   const now = new Date();
// // // // // //                 //   const todayStr = now.toLocaleString('en-CA', { 
// // // // // //                 //     timeZone: 'America/Toronto', 
// // // // // //                 //     year: 'numeric', 
// // // // // //                 //     month: '2-digit', 
// // // // // //                 //     day: '2-digit' 
// // // // // //                 //   }).split(',')[0].split('/').reverse().join('-'); 
// // // // // //                 //   const isUnassignedToday =
// // // // // //                 //     (item.Status === null || item.Status === undefined) &&
// // // // // //                 //     item.Received_Date_EST &&
// // // // // //                 //     item.Received_Date_EST.split(' ')[0] === todayStr;
// // // // // //                 //   let isTodayFollowUp =
// // // // // //                 //     (item.FollowUpDate && item.FollowUpDate.split('T')[0] === todayStr);
// // // // // //                 //   const isUnassignedall =
// // // // // //                 //     (item.Status === null || item.Status === undefined) &&
// // // // // //                 //     item.Received_Date_EST &&
// // // // // //                 //     item.Received_Date_EST.split(' ')[0] !== todayStr;

// // // // // //                 //   // Process each category's latest note
// // // // // //                 //   Object.values(categories).forEach((note) => {
// // // // // //                 //     if (note) {
// // // // // //                 //       const category = note.Category?.toLowerCase() || "";
// // // // // //                 //       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // // // // //                 //       if (category === "connection status") {
// // // // // //                 //         if (categoryDetails === "connected") {
// // // // // //                 //           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // // // // //                 //         } else if (categoryDetails === "not connected") {
// // // // // //                 //           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // // // // //                 //         }
// // // // // //                 //       } else if (category === "prospective") {
// // // // // //                 //         if (categoryDetails === "hot") {
// // // // // //                 //           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // // // // //                 //         } else if (categoryDetails === "warm") {
// // // // // //                 //           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // // // // //                 //         } else if (categoryDetails === "cold") {
// // // // // //                 //           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // // // // //                 //         }
// // // // // //                 //       } else if (category === "next follow-up") {
// // // // // //                 //         if (categoryDetails === todayStr) {
// // // // // //                 //           isTodayFollowUp = true;
// // // // // //                 //         }
// // // // // //                 //         if (categoryDetails) {
// // // // // //                 //           const followUpDate = new Date(categoryDetails);
// // // // // //                 //           const today = new Date(todayStr);
// // // // // //                 //           let color;
// // // // // //                 //           if (followUpDate < today) {
// // // // // //                 //             color = "red"; // Past date
// // // // // //                 //           } else if (followUpDate.toDateString() === today.toDateString()) {
// // // // // //                 //             color = "green"; // Today
// // // // // //                 //           } else {
// // // // // //                 //             color = "gray"; // Future date
// // // // // //                 //           }
// // // // // //                 //           flags.push({ 
// // // // // //                 //             icon: Clock, 
// // // // // //                 //             color, 
// // // // // //                 //             title: `Follow-Up: ${categoryDetails}` 
// // // // // //                 //           });
// // // // // //                 //         }
// // // // // //                 //       }
// // // // // //                 //     }
// // // // // //                 //   });

// // // // // //                 //   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // // // // //                 //   const orderedFlags = new Array(5).fill(null); // Accommodate Follow-Up flag
// // // // // //                 //   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // // // // //                 //     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // // // // //                 //   }
// // // // // //                 //   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // // // // //                 //     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // // // // //                 //       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // // // // //                 //     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // // // // //                 //       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // // // // //                 //     } else {
// // // // // //                 //       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // // // // //                 //     }
// // // // // //                 //   }
// // // // // //                 //   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // // // // //                 //   if (prospectiveFlag) {
// // // // // //                 //     orderedFlags[2] = prospectiveFlag;
// // // // // //                 //   }
// // // // // //                 //   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // // // // //                 //   if (connectionFlag) {
// // // // // //                 //     orderedFlags[3] = connectionFlag;
// // // // // //                 //   }
// // // // // //                 //   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // // // // //                 //   if (followUpFlag) {
// // // // // //                 //     orderedFlags[4] = followUpFlag;
// // // // // //                 //   }

// // // // // //                 //   return (
// // // // // //                 //     <div
// // // // // //                 //       key={index}
// // // // // //                 //       className={`booking-item-my ${
// // // // // //                 //         selectedBooking === item ? "active-booking" : ""
// // // // // //                 //       } ${
// // // // // //                 //         item.Duplicate_Lead_Details &&
// // // // // //                 //         Object.keys(item.Duplicate_Lead_Details).length > 0
// // // // // //                 //           ? "duplicate-item"
// // // // // //                 //           : ""
// // // // // //                 //       } ${
// // // // // //                 //         item.Lead_Source_Status?.toLowerCase() === "return"
// // // // // //                 //           ? "returned-item"
// // // // // //                 //           : ""
// // // // // //                 //       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // // // // //                 //       onClick={() => {
// // // // // //                 //         if (!selectedBooking) setWidth(700);
// // // // // //                 //         setSelectedBooking(item);
// // // // // //                 //       }}
// // // // // //                 //       style={{
// // // // // //                 //         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // // // // //                 //         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // // // // //                 //         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // // // // //                 //         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // // // // //                 //       }}
// // // // // //                 //     >
// // // // // //                 //       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // // // // //                 //       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // //                 //         (colKey) => (
// // // // // //                 //           <span1 key={colKey}>
// // // // // //                 //             {colKey === "AssignedUserID"
// // // // // //                 //               ? userMap[item.AssignedUserID] || "N/A"
// // // // // //                 //               : colKey === "FollowUpDate"
// // // // // //                 //               ? formatFollowUpDate(item[colKey])
// // // // // //                 //               : item[colKey] || "N/A"}
// // // // // //                 //           </span1>
// // // // // //                 //         )
// // // // // //                 //       )}
// // // // // //                 //       <span2 style={{
// // // // // //                 //         display: "flex",
// // // // // //                 //         gap: "8px",
// // // // // //                 //         alignItems: "center",
// // // // // //                 //         justifyContent: "flex-end",
// // // // // //                 //         width: "120px",
// // // // // //                 //       }}>
// // // // // //                 //         {orderedFlags.map((flag, idx) => (
// // // // // //                 //           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // // // // //                 //             {flag && (
// // // // // //                 //               <>
// // // // // //                 //                 <flag.icon
// // // // // //                 //                   className="icon"
// // // // // //                 //                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // // // // //                 //                   title={flag.title}
// // // // // //                 //                 />
// // // // // //                 //                 <div className="custom-tooltip">
// // // // // //                 //                   {flag.title}
// // // // // //                 //                 </div>
// // // // // //                 //               </>
// // // // // //                 //             )}
// // // // // //                 //           </div>
// // // // // //                 //         ))}
// // // // // //                 //       </span2>
// // // // // //                 //     </div>
// // // // // //                 //   );
// // // // // //                 })}
// // // // // //             </div>
// // // // // //           </div>
// // // // // //           {selectedBooking && (
// // // // // //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// // // // // //               <div className="resize-handle" onMouseDown={startResizing}></div>
// // // // // //               <LeadDetails
// // // // // //                 key={selectedBooking.LeadACVLRecordID}
// // // // // //                 booking={selectedBooking}
// // // // // //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// // // // // //                 onClose={() => setSelectedBooking(null)}
// // // // // //                 userDetails={userDetails}
// // // // // //                 accessToken={accessToken}
// // // // // //                 userMap={userMap}
// // // // // //                 updateLeadData={updateLeadData}
// // // // // //                 refetchNotes={refetchNotes}
// // // // // //               />
// // // // // //             </div>
// // // // // //           )}
// // // // // //         </div>
// // // // // //       )}
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // export default Homepage;

// // // // // // // // small changes in the notification and leadpriority icon tooltip

// // // // // // // import React, { useState, useEffect, useRef } from "react";
// // // // // // // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle } from "lucide-react";
// // // // // // // import LeadDetails from "./Leaddetails";
// // // // // // // import TimelineComponent from "./Header";
// // // // // // // import Reports from "./Reports";

// // // // // // // const allColumns = [
// // // // // // //   { key: "Sales_Agent", label: "Sales Agent" },
// // // // // // //   { key: "Customer_Name", label: "Lead Name" },
// // // // // // //   { key: "Move_Date", label: "Move Date" },
// // // // // // //   { key: "Status", label: "Estimate Status" },
// // // // // // //   { key: "OriginCity", label: "From Province" },
// // // // // // //   { key: "DestinationCity", label: "To Province" },
// // // // // // //   { key: "FollowUpDate", label: "Follow Up Date" },
// // // // // // //   { key: "Move_Size", label: "Move Size" },
// // // // // // //   { key: "Lead_Status", label: "Lead Status" },
// // // // // // //   { key: "Move_Type", label: "Move Type" },
// // // // // // //   { key: "Estimate_Amount", label: "Estimate Amount" },
// // // // // // //   { key: "From_Postcode", label: "From Postcode" },
// // // // // // //   { key: "To_Postcode", label: "To Postcode" },
// // // // // // //   { key: "Received_Date_EST", label: "Received Date EST" },
// // // // // // //   { key: "Banner", label: "Banner" },
// // // // // // //   { key: "Lead_Priority", label: "Lead Priority" },
// // // // // // //   { key: "Received_Time_IST", label: "Received Time IST" },
// // // // // // // ];

// // // // // // // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// // // // // // //   const [showReports, setShowReports] = useState(false);
// // // // // // //   const [data, setData] = useState([]);
// // // // // // //   const [filteredData, setFilteredData] = useState([]);
// // // // // // //   const [searchQuery, setSearchQuery] = useState("");
// // // // // // //   const [loading, setLoading] = useState(true);
// // // // // // //   const [error, setError] = useState(null);
// // // // // // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // // // // // //   const [width, setWidth] = useState(350);
// // // // // // //   const [showFilter, setShowFilter] = useState(false);
// // // // // // //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// // // // // // //   const [columnFilters, setColumnFilters] = useState({});
// // // // // // //   const [selectedColumns, setSelectedColumns] = useState(
// // // // // // //     allColumns.slice(0, 7).map((col) => col.key)
// // // // // // //   );
// // // // // // //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // // //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// // // // // // //   const filterRef = useRef(null);
// // // // // // //   const isResizing = useRef(false);
// // // // // // //   const [userMap, setUserMap] = useState({});
// // // // // // //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// // // // // // //   const prevSelectedLeadId = useRef(null);
// // // // // // //   const [allNotes, setAllNotes] = useState([]);

// // // // // // //   const updateLeadData = (updatedBooking) => {
// // // // // // //     setData((prevData) =>
// // // // // // //       prevData.map((lead) =>
// // // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // // //           ? { ...lead, ...updatedBooking }
// // // // // // //           : lead
// // // // // // //       )
// // // // // // //     );
// // // // // // //     setFilteredData((prevFilteredData) =>
// // // // // // //       prevFilteredData.map((lead) =>
// // // // // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // // //           ? { ...lead, ...updatedBooking }
// // // // // // //           : lead
// // // // // // //       )
// // // // // // //     );
// // // // // // //     if (
// // // // // // //       selectedBooking &&
// // // // // // //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // // // // //     ) {
// // // // // // //       setSelectedBooking(updatedBooking);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const refetchNotes = () => {
// // // // // // //     fetchAllNotes();
// // // // // // //   };

// // // // // // //   const formatFollowUpDate = (date) => {
// // // // // // //     if (!date) return "N/A";
// // // // // // //     return date.replace("T", " ");
// // // // // // //   };

// // // // // // //   const handleDefaultSort = () => {
// // // // // // //     setSearchQuery("");
// // // // // // //     setColumnFilters({});
// // // // // // //     setIsGlobalSearch(false);
// // // // // // //     setIsDefaultSort(true);
// // // // // // //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// // // // // // //     fetchLeads();
// // // // // // //   };

// // // // // // //   useEffect(() => {
// // // // // // //     const fetchUserData = async () => {
// // // // // // //       try {
// // // // // // //         const response = await fetch(
// // // // // // //           "https://salesjet-10097049716.catalystappsail.com/userdata",
// // // // // // //           {
// // // // // // //             method: "GET",
// // // // // // //             headers: {
// // // // // // //               Authorization: `Bearer ${accessToken}`,
// // // // // // //               "Content-Type": "application/json",
// // // // // // //             },
// // // // // // //           }
// // // // // // //         );
// // // // // // //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // //         const result = await response.json();
// // // // // // //         const userMapping = result.data.reduce((acc, user) => {
// // // // // // //           acc[user.userId] = user.pseudoname;
// // // // // // //           return acc;
// // // // // // //         }, {});
// // // // // // //         setUserMap(userMapping);
// // // // // // //       } catch (err) {
// // // // // // //         console.error("Error fetching user data:", err.message);
// // // // // // //       }
// // // // // // //     };
// // // // // // //     fetchUserData();
// // // // // // //   }, [accessToken]);

// // // // // // //   const fetchLeads = async () => {
// // // // // // //     try {
// // // // // // //       setLoading(true);
// // // // // // //       const response = await fetch(
// // // // // // //         "https://salesjet-10097049716.catalystappsail.com/leadsdata",
// // // // // // //         {
// // // // // // //           method: "GET",
// // // // // // //           headers: {
// // // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // // //             "Content-Type": "application/json",
// // // // // // //           },
// // // // // // //         }
// // // // // // //       );
// // // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // //       const result = await response.json();
// // // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // // //       setData(leads);
// // // // // // //       setFilteredData(leads);
// // // // // // //     } catch (err) {
// // // // // // //       setError(err.message);
// // // // // // //       console.error("Error fetching leads:", err.message);
// // // // // // //     } finally {
// // // // // // //       setLoading(false);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const fetchAllNotes = async () => {
// // // // // // //     try {
// // // // // // //       const response = await fetch(
// // // // // // //         "https://salesjet-10097049716.catalystappsail.com/allleadnotes",
// // // // // // //         {
// // // // // // //           method: "GET",
// // // // // // //           headers: {
// // // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // // //             "Content-Type": "application/json",
// // // // // // //           },
// // // // // // //         }
// // // // // // //       );
// // // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // //       const result = await response.json();
// // // // // // //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// // // // // // //     } catch (err) {
// // // // // // //       console.error("Error fetching all lead notes:", err.message);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   useEffect(() => {
// // // // // // //     if (!isGlobalSearch) {
// // // // // // //       fetchLeads();
// // // // // // //       fetchAllNotes();
// // // // // // //     }
// // // // // // //   }, [accessToken, isGlobalSearch]);

// // // // // // //   // Apply default sort on component mount
// // // // // // //   useEffect(() => {
// // // // // // //     handleDefaultSort();
// // // // // // //   }, []);

// // // // // // //   useEffect(() => {
// // // // // // //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// // // // // // //       prevSelectedLeadId.current = selectedLeadId;
// // // // // // //       setIsGlobalSearch(true);
// // // // // // //       setColumnFilters({});
// // // // // // //       handleGlobalSearch(selectedLeadId.toString());
// // // // // // //     }
// // // // // // //   }, [selectedLeadId]);

// // // // // // //   useEffect(() => {
// // // // // // //     if (selectedLeadId && filteredData.length > 0) {
// // // // // // //       const matchingLead = filteredData.find(
// // // // // // //         (lead) =>
// // // // // // //           lead.LeadACVLRecordID &&
// // // // // // //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// // // // // // //       );
// // // // // // //       if (matchingLead) {
// // // // // // //         setSelectedBooking(matchingLead);
// // // // // // //         setWidth(700);
// // // // // // //       } else {
// // // // // // //         setSelectedBooking(null);
// // // // // // //       }
// // // // // // //     } else if (selectedLeadId && filteredData.length === 0) {
// // // // // // //       setSelectedBooking(null);
// // // // // // //     }
// // // // // // //   }, [filteredData, selectedLeadId]);

// // // // // // //   useEffect(() => {
// // // // // // //     if (isGlobalSearch) {
// // // // // // //       return;
// // // // // // //     }
// // // // // // //     let filtered = [...data];
// // // // // // //     if (searchQuery.trim()) {
// // // // // // //       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // //       filtered = filtered.filter((lead) =>
// // // // // // //         Object.entries(lead).some(([key, value]) => {
// // // // // // //           if (!value) return false;
// // // // // // //           const normalizedValue = value
// // // // // // //             .toString()
// // // // // // //             .replace(/[^a-zA-Z0-9]/g, "")
// // // // // // //             .toLowerCase();
// // // // // // //           return normalizedValue.includes(normalizedQuery);
// // // // // // //         })
// // // // // // //       );
// // // // // // //     }
// // // // // // //     Object.keys(columnFilters).forEach((key) => {
// // // // // // //       const filterValue = columnFilters[key]?.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // //       if (filterValue) {
// // // // // // //         filtered = filtered.filter((lead) => {
// // // // // // //           const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // //           return value?.includes(filterValue);
// // // // // // //         });
// // // // // // //       }
// // // // // // //     });
// // // // // // //     setFilteredData(filtered);
// // // // // // //   }, [data, searchQuery, columnFilters, isGlobalSearch]);

// // // // // // //   const handleSearchChange = (query) => {
// // // // // // //     setSearchQuery(query);
// // // // // // //     setIsGlobalSearch(false);
// // // // // // //     setColumnFilters({});
// // // // // // //   };

// // // // // // //   const handleGlobalSearch = async (query) => {
// // // // // // //     setLoading(true);
// // // // // // //     setIsDefaultSort(false);
// // // // // // //     setIsGlobalSearch(true);
// // // // // // //     try {
// // // // // // //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // // // // //       const response = await fetch(
// // // // // // //         "https://salesjet-10097049716.catalystappsail.com/globalsearch",
// // // // // // //         {
// // // // // // //           method: "POST",
// // // // // // //           headers: {
// // // // // // //             Authorization: `Bearer ${accessToken}`,
// // // // // // //             "Content-Type": "application/json",
// // // // // // //           },
// // // // // // //           body: JSON.stringify({ query: normalizedQuery }),
// // // // // // //         }
// // // // // // //       );
// // // // // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // // // // //       const result = await response.json();
// // // // // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // // // // //       setFilteredData(leads);
// // // // // // //       setSearchQuery(query);
// // // // // // //       fetchAllNotes();
// // // // // // //     } catch (err) {
// // // // // // //       console.error("Global search error:", err.message);
// // // // // // //       setError(err.message);
// // // // // // //     } finally {
// // // // // // //       setLoading(false);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const handleSort = (key) => {
// // // // // // //     setIsDefaultSort(false);
// // // // // // //     setSortConfig((prev) =>
// // // // // // //       prev.key === key
// // // // // // //         ? {
// // // // // // //             key,
// // // // // // //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// // // // // // //           }
// // // // // // //         : { key, direction: "ascending" }
// // // // // // //     );
// // // // // // //   };

// // // // // // //   const sortedData = React.useMemo(() => {
// // // // // // //     let sortableData = [...filteredData];
// // // // // // //     if (isDefaultSort) {
// // // // // // //       // Get current date in EST (America/Toronto)
// // // // // // //       const now = new Date();
// // // // // // //       const todayStr = now.toLocaleString('en-CA', { 
// // // // // // //         timeZone: 'America/Toronto', 
// // // // // // //         year: 'numeric', 
// // // // // // //         month: '2-digit', 
// // // // // // //         day: '2-digit' 
// // // // // // //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// // // // // // //       // Custom sorting logic
// // // // // // //       sortableData.sort((a, b) => {
// // // // // // //         const isUnassignedA = a.Status === null || a.Status === undefined;
// // // // // // //         const isUnassignedB = b.Status === null || b.Status === undefined;
// // // // // // //         const timeA = a.Received_Date_EST;
// // // // // // //         const timeB = b.Received_Date_EST;
// // // // // // //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// // // // // // //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// // // // // // //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// // // // // // //         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
// // // // // // //           return -1;
// // // // // // //         }
// // // // // // //         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
// // // // // // //           return 1;
// // // // // // //         }

// // // // // // //         // Step 2: Leads with FollowUpDate date as today (EST)
// // // // // // //         if (followUpA === todayStr && followUpB !== todayStr) return -1;
// // // // // // //         if (followUpB === todayStr && followUpA !== todayStr) return 1;

// // // // // // //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// // // // // // //         const idA = Number(a.LeadACVLRecordID || 0);
// // // // // // //         const idB = Number(b.LeadACVLRecordID || 0);
// // // // // // //         return idB - idA;
// // // // // // //       });
// // // // // // //     } else if (sortConfig.key) {
// // // // // // //       sortableData.sort((a, b) => {
// // // // // // //         let aVal = a[sortConfig.key];
// // // // // // //         let bVal = b[sortConfig.key];
// // // // // // //         // Handle null or undefined values
// // // // // // //         if (aVal === undefined || aVal === null) return 1;
// // // // // // //         if (bVal === undefined || bVal === null) return -1;
// // // // // // //         // Handle LeadACVLRecordID specifically as a number
// // // // // // //         if (sortConfig.key === "LeadACVLRecordID") {
// // // // // // //           aVal = Number(aVal);
// // // // // // //           bVal = Number(bVal);
// // // // // // //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // // //         }
// // // // // // //         // Handle date fields
// // // // // // //         const isDateField = [
// // // // // // //           "Move_Date",
// // // // // // //           "Received_Date_EST",
// // // // // // //           "Received_Time_IST",
// // // // // // //           "FollowUpDate",
// // // // // // //         ].includes(sortConfig.key);
// // // // // // //         if (isDateField) {
// // // // // // //           const dateA = new Date(aVal);
// // // // // // //           const dateB = new Date(bVal);
// // // // // // //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// // // // // // //         }
// // // // // // //         // Handle string fields
// // // // // // //         if (typeof aVal === "string" && typeof bVal === "string") {
// // // // // // //           return sortConfig.direction === "ascending"
// // // // // // //             ? aVal.localeCompare(bVal)
// // // // // // //             : bVal.localeCompare(bVal);
// // // // // // //         }
// // // // // // //         // Handle numeric fields
// // // // // // //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // // // // //       });
// // // // // // //     }
// // // // // // //     return sortableData;
// // // // // // //   }, [filteredData, sortConfig, isDefaultSort]);

// // // // // // //   const notesByLead = React.useMemo(() => {
// // // // // // //     const map = {};
// // // // // // //     allNotes.forEach((note) => {
// // // // // // //       const id = note.LeadACVLRecordID;
// // // // // // //       if (id) {
// // // // // // //         if (!map[id]) {
// // // // // // //           map[id] = { notes: [], latestByCategory: {} };
// // // // // // //         }
// // // // // // //         map[id].notes.push(note);
// // // // // // //       }
// // // // // // //     });
// // // // // // //     Object.keys(map).forEach((leadId) => {
// // // // // // //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// // // // // // //       const categoryMap = {};
// // // // // // //       map[leadId].notes.forEach((note) => {
// // // // // // //         const category = note.Category?.toLowerCase() || "";
// // // // // // //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// // // // // // //           categoryMap[category] = note;
// // // // // // //         }
// // // // // // //       });
// // // // // // //       map[leadId].latestByCategory = categoryMap;
// // // // // // //     });
// // // // // // //     return map;
// // // // // // //   }, [allNotes]);

// // // // // // //   const startResizing = (e) => {
// // // // // // //     isResizing.current = true;
// // // // // // //     document.addEventListener("mousemove", resize);
// // // // // // //     document.addEventListener("mouseup", stopResizing);
// // // // // // //   };

// // // // // // //   const resize = (e) => {
// // // // // // //     if (!isResizing.current) return;
// // // // // // //     const minWidth = 500;
// // // // // // //     const maxWidth = window.innerWidth * 0.7;
// // // // // // //     let newWidth = window.innerWidth - e.clientX;
// // // // // // //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// // // // // // //       setWidth(newWidth);
// // // // // // //     }
// // // // // // //   };

// // // // // // //   const stopResizing = () => {
// // // // // // //     isResizing.current = false;
// // // // // // //     document.removeEventListener("mousemove", resize);
// // // // // // //     document.removeEventListener("mouseup", stopResizing);
// // // // // // //   };

// // // // // // //   useEffect(() => {
// // // // // // //     const handleClickOutside = (event) => {
// // // // // // //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// // // // // // //         setShowFilter(false);
// // // // // // //       }
// // // // // // //     };
// // // // // // //     document.addEventListener("mousedown", handleClickOutside);
// // // // // // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // // // // // //   }, []);

// // // // // // //   const handleColumnChange = (event) => {
// // // // // // //     const value = event.target.value;
// // // // // // //     setSelectedColumns((prev) =>
// // // // // // //       prev.includes(value)
// // // // // // //         ? prev.filter((col) => col !== value)
// // // // // // //         : prev.length < 7
// // // // // // //         ? [...prev, value]
// // // // // // //         : prev
// // // // // // //     );
// // // // // // //   };

// // // // // // //   const today = new Date().toISOString().split('T')[0];

// // // // // // //   return (
// // // // // // //     <div>
// // // // // // //       <>
// // // // // // //         <TimelineComponent
// // // // // // //           userDetails={userDetails}
// // // // // // //           accessToken={accessToken}
// // // // // // //           onSearchChange={handleSearchChange}
// // // // // // //           onGlobalSearch={handleGlobalSearch}
// // // // // // //           connectionStatus={connectionStatus}
// // // // // // //           onShowReports={() => setShowReports(true)}
// // // // // // //         />
// // // // // // //       </>
// // // // // // //       {showReports && (
// // // // // // //         <>
// // // // // // //           <button onClick={() => setShowReports(false)}>✖ Close Report</button>
// // // // // // //           <Reports />
// // // // // // //         </>
// // // // // // //       )}
// // // // // // //       {!showReports && (
// // // // // // //         <div className="table-container">
// // // // // // //           <div
// // // // // // //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// // // // // // //             style={{ flex: selectedBooking ? "1" : "2" }}
// // // // // // //           >
// // // // // // //             <div>
// // // // // // //               <div className="bookings-header-my">
// // // // // // //                 <span
// // // // // // //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// // // // // // //                   onClick={() => handleSort("LeadACVLRecordID")}
// // // // // // //                   style={{ cursor: "pointer" }}
// // // // // // //                 >
// // // // // // //                   ACVL LeadID
// // // // // // //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// // // // // // //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // // //                 </span>
// // // // // // //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // // //                   (colKey) => {
// // // // // // //                     const column = allColumns.find((c) => c.key === colKey);
// // // // // // //                     const isSorted = sortConfig.key === colKey;
// // // // // // //                     return column ? (
// // // // // // //                       <span
// // // // // // //                         key={colKey}
// // // // // // //                         className="sortable-header"
// // // // // // //                         onClick={() => handleSort(colKey)}
// // // // // // //                         style={{ cursor: "pointer" }}
// // // // // // //                       >
// // // // // // //                         {column.label}
// // // // // // //                         {!isDefaultSort && isSorted &&
// // // // // // //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // // // // //                       </span>
// // // // // // //                     ) : null;
// // // // // // //                   }
// // // // // // //                 )}
// // // // // // //                 <span2>
// // // // // // //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// // // // // // //                     <div>
// // // // // // //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// // // // // // //                     </div>
// // // // // // //                     <div>
// // // // // // //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// // // // // // //                     </div>
// // // // // // //                     <div>
// // // // // // //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// // // // // // //                     </div>
// // // // // // //                     <div>
// // // // // // //                       <Search
// // // // // // //                         className="filter-icon"
// // // // // // //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// // // // // // //                         title="Advanced column search"
// // // // // // //                       />
// // // // // // //                     </div>
// // // // // // //                   </div>
// // // // // // //                 </span2>
// // // // // // //                 {showFilter && (
// // // // // // //                   <div className="filter-dropdown" ref={filterRef}>
// // // // // // //                     {allColumns.map((col) => (
// // // // // // //                       <label key={col.key}>
// // // // // // //                         <input
// // // // // // //                           type="checkbox"
// // // // // // //                           value={col.key}
// // // // // // //                           checked={selectedColumns.includes(col.key)}
// // // // // // //                           onChange={handleColumnChange}
// // // // // // //                           disabled={
// // // // // // //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// // // // // // //                           }
// // // // // // //                         />
// // // // // // //                         {col.label}
// // // // // // //                       </label>
// // // // // // //                     ))}
// // // // // // //                   </div>
// // // // // // //                 )}
// // // // // // //               </div>
// // // // // // //               {showAdvancedFilter && (
// // // // // // //                 <div className="column-filter-row">
// // // // // // //                   <span className="filter-input">
// // // // // // //                     <input
// // // // // // //                       placeholder="Lead ID"
// // // // // // //                       value={columnFilters["LeadACVLRecordID"] || ""}
// // // // // // //                       onChange={(e) =>
// // // // // // //                         setColumnFilters({
// // // // // // //                           ...columnFilters,
// // // // // // //                           LeadACVLRecordID: e.target.value,
// // // // // // //                         })
// // // // // // //                       }
// // // // // // //                     />
// // // // // // //                   </span>
// // // // // // //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // // //                     (colKey) => (
// // // // // // //                       <span key={colKey} className="filter-input">
// // // // // // //                         <input
// // // // // // //                           placeholder={
// // // // // // //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// // // // // // //                           }
// // // // // // //                           value={columnFilters[colKey] || ""}
// // // // // // //                           onChange={(e) =>
// // // // // // //                             setColumnFilters({
// // // // // // //                               ...columnFilters,
// // // // // // //                               [colKey]: e.target.value,
// // // // // // //                             })
// // // // // // //                           }
// // // // // // //                         />
// // // // // // //                       </span>
// // // // // // //                     )
// // // // // // //                   )}
// // // // // // //                   <span className="filter-icons-space" />
// // // // // // //                 </div>
// // // // // // //               )}
// // // // // // //               {loading && <p>Loading...</p>}
// // // // // // //               {error && <p className="error">{error}</p>}
// // // // // // //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// // // // // // //               {!loading &&
// // // // // // //                 !error &&
// // // // // // //                 sortedData.map((item, index) => {
// // // // // // //                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // // // // // //                   const categories = leadNotesData.latestByCategory;
// // // // // // //                   let flags = [];
// // // // // // //                   const now = new Date();
// // // // // // //                   const todayStr = now.toLocaleString('en-CA', { 
// // // // // // //                     timeZone: 'America/Toronto', 
// // // // // // //                     year: 'numeric', 
// // // // // // //                     month: '2-digit', 
// // // // // // //                     day: '2-digit' 
// // // // // // //                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// // // // // // //                   const isUnassignedToday =
// // // // // // //                     (item.Status === null || item.Status === undefined) &&
// // // // // // //                     item.Received_Date_EST &&
// // // // // // //                     item.Received_Date_EST.split(' ')[0] === todayStr;
// // // // // // //                   const isUnassignedall =
// // // // // // //                     (item.Status === null || item.Status === undefined) &&
// // // // // // //                     item.Received_Date_EST &&
// // // // // // //                     item.Received_Date_EST.split(' ')[0] !== todayStr;
// // // // // // //                   let isTodayFollowUp = false;

// // // // // // //                   // Collect and process follow-up dates
// // // // // // //                   const followUpDates = [];
                  
// // // // // // //                   // Add follow-up date from notes (next follow-up category)
// // // // // // //                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // // // // // //                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // // //                     if (noteDate) {
// // // // // // //                       followUpDates.push(noteDate);
// // // // // // //                     }
// // // // // // //                   }

// // // // // // //                   // Add follow-up date from item.FollowUpDate
// // // // // // //                   if (item.FollowUpDate) {
// // // // // // //                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// // // // // // //                     if (itemDate && !followUpDates.includes(itemDate)) {
// // // // // // //                       followUpDates.push(itemDate);
// // // // // // //                     }
// // // // // // //                   }

// // // // // // //                   // Select the most relevant follow-up date
// // // // // // //                   let selectedFollowUpDate = null;
// // // // // // //                   if (followUpDates.length > 0) {
// // // // // // //                     // Prioritize: today's date, then past date, then future date
// // // // // // //                     const today = new Date(todayStr);
// // // // // // //                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// // // // // // //                       const followUpDate = new Date(dateStr);
// // // // // // //                       if (!selected) return dateStr;
// // // // // // //                       const selectedDate = new Date(selected);
// // // // // // //                       if (dateStr === todayStr) return dateStr; // Prioritize today's date
// // // // // // //                       if (selected === todayStr) return selected;
// // // // // // //                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// // // // // // //                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// // // // // // //                       return selected; // Keep first date if no priority
// // // // // // //                     }, null);

// // // // // // //                     if (selectedFollowUpDate) {
// // // // // // //                       const followUpDate = new Date(selectedFollowUpDate);
// // // // // // //                       isTodayFollowUp = selectedFollowUpDate === todayStr;
// // // // // // //                       let color;
// // // // // // //                       if (followUpDate < today && !isTodayFollowUp) {
// // // // // // //                         color = "red"; // Past date
// // // // // // //                       } else if (isTodayFollowUp) {
// // // // // // //                         color = "green"; // Today
// // // // // // //                       } else {
// // // // // // //                         color = "gray"; // Future date
// // // // // // //                       }
// // // // // // //                       flags.push({ 
// // // // // // //                         icon: Clock, 
// // // // // // //                         color, 
// // // // // // //                         title: `Follow-Up: ${selectedFollowUpDate}` 
// // // // // // //                       });
// // // // // // //                     }
// // // // // // //                   }

// // // // // // //                   // Process other categories
// // // // // // //                   Object.values(categories).forEach((note) => {
// // // // // // //                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// // // // // // //                       const category = note.Category?.toLowerCase() || "";
// // // // // // //                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // // // // // //                       if (category === "connection status") {
// // // // // // //                         if (categoryDetails === "connected") {
// // // // // // //                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // // // // // //                         } else if (categoryDetails === "not connected") {
// // // // // // //                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // // // // // //                         }
// // // // // // //                       } else if (category === "prospective") {
// // // // // // //                         if (categoryDetails === "hot") {
// // // // // // //                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // // // // // //                         } else if (categoryDetails === "warm") {
// // // // // // //                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // // // // // //                         } else if (categoryDetails === "cold") {
// // // // // // //                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // // // // // //                         }
// // // // // // //                       }
// // // // // // //                     }
// // // // // // //                   });

// // // // // // //                   // Process Lead_Priority for left side icon
// // // // // // //                   let priorityFlag = null;
// // // // // // //                   if (item.Lead_Priority) {
// // // // // // //                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
// // // // // // //                     let color, title;
// // // // // // //                     if (priority === "high") {
// // // // // // //                       color = "red";
// // // // // // //                       title = "High";
// // // // // // //                     } else if (priority === "medium") {
// // // // // // //                       color = "purple";
// // // // // // //                       title = "Medium";
// // // // // // //                     } else if (priority === "low") {
// // // // // // //                       color = "green";
// // // // // // //                       title = "Low";
// // // // // // //                     }
// // // // // // //                     if (color && title) {
// // // // // // //                       priorityFlag = { icon: AlertTriangle, color, title };
// // // // // // //                     }
// // // // // // //                   }

// // // // // // //                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // // // // // //                   const orderedFlags = new Array(5).fill(null);
// // // // // // //                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // // // // // //                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // // // // // //                   }
// // // // // // //                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // // // // // //                     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // // // // // //                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // // // // // //                     } else {
// // // // // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // // // // // //                     }
// // // // // // //                   }
// // // // // // //                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // // // // // //                   if (prospectiveFlag) {
// // // // // // //                     orderedFlags[2] = prospectiveFlag;
// // // // // // //                   }
// // // // // // //                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // // // // // //                   if (connectionFlag) {
// // // // // // //                     orderedFlags[3] = connectionFlag;
// // // // // // //                   }
// // // // // // //                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // // // // // //                   if (followUpFlag) {
// // // // // // //                     orderedFlags[4] = followUpFlag;
// // // // // // //                   }

// // // // // // //                   return (
// // // // // // //                     <div
// // // // // // //                       key={index}
// // // // // // //                       className={`booking-item-my ${
// // // // // // //                         selectedBooking === item ? "active-booking" : ""
// // // // // // //                       } ${
// // // // // // //                         item.Duplicate_Lead_Details &&
// // // // // // //                         Object.keys(item.Duplicate_Lead_Details).length > 0
// // // // // // //                           ? "duplicate-item"
// // // // // // //                           : ""
// // // // // // //                       } ${
// // // // // // //                         item.Lead_Source_Status?.toLowerCase() === "return"
// // // // // // //                           ? "returned-item"
// // // // // // //                           : ""
// // // // // // //                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // // // // // //                       onClick={() => {
// // // // // // //                         if (!selectedBooking) setWidth(700);
// // // // // // //                         setSelectedBooking(item);
// // // // // // //                       }}
// // // // // // //                       style={{
// // // // // // //                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // // // // // //                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // // // // // //                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // // // // // //                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // // // // // //                       }}
// // // // // // //                     >
// // // // // // //                       {priorityFlag && (
// // // // // // //                         <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
// // // // // // //                           <>
// // // // // // //                             <priorityFlag.icon
// // // // // // //                               className="icon"
// // // // // // //                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
// // // // // // //                               title={priorityFlag.title}
// // // // // // //                             />
// // // // // // //                             <div className="custom-tooltip1">
// // // // // // //                               {priorityFlag.title}
// // // // // // //                             </div>
// // // // // // //                           </>
// // // // // // //                         </div>
// // // // // // //                       )}
// // // // // // //                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // // // // // //                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // // // // //                         (colKey) => (
// // // // // // //                           <span1 key={colKey}>
// // // // // // //                             {colKey === "AssignedUserID"
// // // // // // //                               ? userMap[item.AssignedUserID] || "N/A"
// // // // // // //                               : colKey === "FollowUpDate"
// // // // // // //                               ? formatFollowUpDate(item[colKey])
// // // // // // //                               : item[colKey] || "N/A"}
// // // // // // //                           </span1>
// // // // // // //                         )
// // // // // // //                       )}
// // // // // // //                       <span2 style={{
// // // // // // //                         display: "flex",
// // // // // // //                         gap: "8px",
// // // // // // //                         alignItems: "center",
// // // // // // //                         justifyContent: "flex-end",
// // // // // // //                         width: "120px",
// // // // // // //                       }}>
// // // // // // //                         {orderedFlags.map((flag, idx) => (
// // // // // // //                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // // // // // //                             {flag && (
// // // // // // //                               <>
// // // // // // //                                 <flag.icon
// // // // // // //                                   className="icon"
// // // // // // //                                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // // // // // //                                   title={flag.title}
// // // // // // //                                 />
// // // // // // //                                 <div className="custom-tooltip">
// // // // // // //                                   {flag.title}
// // // // // // //                                 </div>
// // // // // // //                               </>
// // // // // // //                             )}
// // // // // // //                           </div>
// // // // // // //                         ))}
// // // // // // //                       </span2>
// // // // // // //                     </div>
// // // // // // //                   );
// // // // // // //                 })}
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //           {selectedBooking && (
// // // // // // //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// // // // // // //               <div className="resize-handle" onMouseDown={startResizing}></div>
// // // // // // //               <LeadDetails
// // // // // // //                 key={selectedBooking.LeadACVLRecordID}
// // // // // // //                 booking={selectedBooking}
// // // // // // //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// // // // // // //                 onClose={() => setSelectedBooking(null)}
// // // // // // //                 userDetails={userDetails}
// // // // // // //                 accessToken={accessToken}
// // // // // // //                 userMap={userMap}
// // // // // // //                 updateLeadData={updateLeadData}
// // // // // // //                 refetchNotes={refetchNotes}
// // // // // // //               />
// // // // // // //             </div>
// // // // // // //           )}
// // // // // // //         </div>
// // // // // // //       )}
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default Homepage;

// // // import React, { useState, useEffect, useRef } from "react";
// // // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle } from "lucide-react";
// // // import LeadDetails from "./Leaddetails";
// // // import TimelineComponent from "./Header";
// // // import Reports from "./Reports";

// // // const allColumns = [
// // //   { key: "Sales_Agent", label: "Sales Agent" },
// // //   { key: "Customer_Name", label: "Lead Name" },
// // //   { key: "Move_Date", label: "Move Date" },
// // //   { key: "Status", label: "Estimate Status" },
// // //   { key: "OriginCity", label: "From Province" },
// // //   { key: "DestinationCity", label: "To Province" },
// // //   { key: "FollowUpDate", label: "Follow Up Date" },
// // //   { key: "Move_Size", label: "Move Size" },
// // //   { key: "Lead_Status", label: "Lead Status" },
// // //   { key: "Move_Type", label: "Move Type" },
// // //   { key: "Estimate_Amount", label: "Estimate Amount" },
// // //   { key: "From_Postcode", label: "From Postcode" },
// // //   { key: "To_Postcode", label: "To Postcode" },
// // //   { key: "Received_Date_EST", label: "Received Date EST" },
// // //   { key: "Banner", label: "Banner" },
// // //   { key: "Lead_Priority", label: "Lead Priority" },
// // //   { key: "Received_Time_IST", label: "Received Time IST" },
// // // ];

// // // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// // //   const [showReports, setShowReports] = useState(false);
// // //   const [data, setData] = useState([]);
// // //   const [filteredData, setFilteredData] = useState([]);
// // //   const [searchQuery, setSearchQuery] = useState("");
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // //   const [width, setWidth] = useState(350);
// // //   const [showFilter, setShowFilter] = useState(false);
// // //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// // //   const [columnFilters, setColumnFilters] = useState({});
// // //   const [selectedColumns, setSelectedColumns] = useState(
// // //     allColumns.slice(0, 7).map((col) => col.key)
// // //   );
// // //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// // //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// // //   const filterRef = useRef(null);
// // //   const isResizing = useRef(false);
// // //   const [userMap, setUserMap] = useState({});
// // //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// // //   const prevSelectedLeadId = useRef(null);
// // //   const [allNotes, setAllNotes] = useState([]);

// // //   const updateLeadData = (updatedBooking) => {
// // //     setData((prevData) =>
// // //       prevData.map((lead) =>
// // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // //           ? { ...lead, ...updatedBooking }
// // //           : lead
// // //       )
// // //     );
// // //     setFilteredData((prevFilteredData) =>
// // //       prevFilteredData.map((lead) =>
// // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // //           ? { ...lead, ...updatedBooking }
// // //           : lead
// // //       )
// // //     );
// // //     if (
// // //       selectedBooking &&
// // //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // //     ) {
// // //       setSelectedBooking(updatedBooking);
// // //     }
// // //   };

// // //   const refetchNotes = () => {
// // //     fetchAllNotes();
// // //   };

// // //   const formatFollowUpDate = (date) => {
// // //     if (!date) return "N/A";
// // //     return date.replace("T", " ");
// // //   };

// // //   const handleDefaultSort = () => {
// // //     setSearchQuery("");
// // //     setColumnFilters({});
// // //     setIsGlobalSearch(false);
// // //     setIsDefaultSort(true);
// // //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// // //     fetchLeads();
// // //   };

// // //   useEffect(() => {
// // //     const fetchUserData = async () => {
// // //       try {
// // //         const response = await fetch(
// // //           "https://salesjet-10097049716.catalystappsail.com/userdata",
// // //           {
// // //             method: "GET",
// // //             headers: {
// // //               Authorization: `Bearer ${accessToken}`,
// // //               "Content-Type": "application/json",
// // //             },
// // //           }
// // //         );
// // //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //         const result = await response.json();
// // //         const userMapping = result.data.reduce((acc, user) => {
// // //           acc[user.userId] = user.pseudoname;
// // //           return acc;
// // //         }, {});
// // //         setUserMap(userMapping);
// // //       } catch (err) {
// // //         console.error("Error fetching user data:", err.message);
// // //       }
// // //     };
// // //     fetchUserData();
// // //   }, [accessToken]);

// // //   const fetchLeads = async () => {
// // //     try {
// // //       setLoading(true);
// // //       const response = await fetch(
// // //         "https://salesjet-10097049716.catalystappsail.com/leadsdata",
// // //         {
// // //           method: "GET",
// // //           headers: {
// // //             Authorization: `Bearer ${accessToken}`,
// // //             "Content-Type": "application/json",
// // //           },
// // //         }
// // //       );
// // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //       const result = await response.json();
// // //       const leads = Array.isArray(result.data) ? result.data : [];
// // //       setData(leads);
// // //       setFilteredData(leads);
// // //     } catch (err) {
// // //       setError(err.message);
// // //       console.error("Error fetching leads:", err.message);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const fetchAllNotes = async () => {
// // //     try {
// // //       const response = await fetch(
// // //         "https://salesjet-10097049716.catalystappsail.com/allleadnotes",
// // //         {
// // //           method: "GET",
// // //           headers: {
// // //             Authorization: `Bearer ${accessToken}`,
// // //             "Content-Type": "application/json",
// // //           },
// // //         }
// // //       );
// // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //       const result = await response.json();
// // //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// // //     } catch (err) {
// // //       console.error("Error fetching all lead notes:", err.message);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (!isGlobalSearch) {
// // //       fetchLeads();
// // //       fetchAllNotes();
// // //     }
// // //   }, [accessToken, isGlobalSearch]);

// // //   useEffect(() => {
// // //     handleDefaultSort();
// // //   }, []);

// // //   useEffect(() => {
// // //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// // //       prevSelectedLeadId.current = selectedLeadId;
// // //       setIsGlobalSearch(true);
// // //       setColumnFilters({});
// // //       handleGlobalSearch(selectedLeadId.toString());
// // //     }
// // //   }, [selectedLeadId]);

// // //   useEffect(() => {
// // //     if (selectedLeadId && filteredData.length > 0) {
// // //       const matchingLead = filteredData.find(
// // //         (lead) =>
// // //           lead.LeadACVLRecordID &&
// // //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// // //       );
// // //       if (matchingLead) {
// // //         setSelectedBooking(matchingLead);
// // //         setWidth(700);
// // //       } else {
// // //         setSelectedBooking(null);
// // //       }
// // //     } else if (selectedLeadId && filteredData.length === 0) {
// // //       setSelectedBooking(null);
// // //     }
// // //   }, [filteredData, selectedLeadId]);

// // //   useEffect(() => {
// // //     if (isGlobalSearch) {
// // //       return;
// // //     }
// // //     let filtered = [...data];
// // //     if (searchQuery.trim()) {
// // //       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //       filtered = filtered.filter((lead) =>
// // //         Object.entries(lead).some(([key, value]) => {
// // //           if (!value) return false;
// // //           const normalizedValue = value
// // //             .toString()
// // //             .replace(/[^a-zA-Z0-9]/g, "")
// // //             .toLowerCase();
// // //           return normalizedValue.includes(normalizedQuery);
// // //         })
// // //       );
// // //     }
// // //     Object.keys(columnFilters).forEach((key) => {
// // //       const rawFilter = columnFilters[key];
// // //       if (rawFilter) {
// // //         const trimmedRawFilter = rawFilter.trim();
// // //         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
// // //         if (isNAFilter) {
// // //           filtered = filtered.filter((lead) => {
// // //             const value = lead[key];
// // //             return value === null || value === undefined || value === "" || value === "N/A";
// // //           });
// // //         } else if (normalizedFilter) {
// // //           filtered = filtered.filter((lead) => {
// // //             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //             return value?.includes(normalizedFilter);
// // //           });
// // //         }
// // //       }
// // //     });
// // //     setFilteredData(filtered);
// // //   }, [data, searchQuery, columnFilters, isGlobalSearch]);

// // //   const handleSearchChange = (query) => {
// // //     setSearchQuery(query);
// // //     setIsGlobalSearch(false);
// // //     setColumnFilters({});
// // //   };

// // //   const handleGlobalSearch = async (query) => {
// // //     setLoading(true);
// // //     setIsDefaultSort(false);
// // //     setIsGlobalSearch(true);
// // //     try {
// // //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // //       const response = await fetch(
// // //         "https://salesjet-10097049716.catalystappsail.com/globalsearch",
// // //         {
// // //           method: "POST",
// // //           headers: {
// // //             Authorization: `Bearer ${accessToken}`,
// // //             "Content-Type": "application/json",
// // //           },
// // //           body: JSON.stringify({ query: normalizedQuery }),
// // //         }
// // //       );
// // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // //       const result = await response.json();
// // //       const leads = Array.isArray(result.data) ? result.data : [];
// // //       setFilteredData(leads);
// // //       setSearchQuery(query);
// // //       fetchAllNotes();
// // //     } catch (err) {
// // //       console.error("Global search error:", err.message);
// // //       setError(err.message);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const handleSort = (key) => {
// // //     setIsDefaultSort(false);
// // //     setSortConfig((prev) =>
// // //       prev.key === key
// // //         ? {
// // //             key,
// // //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// // //           }
// // //         : { key, direction: "ascending" }
// // //     );
// // //   };

// // //   const sortedData = React.useMemo(() => {
// // //     let sortableData = [...filteredData];
// // //     if (isDefaultSort) {
// // //       // Get current date in EST (America/Toronto)
// // //       const now = new Date();
// // //       const todayStr = now.toLocaleString('en-CA', { 
// // //         timeZone: 'America/Toronto', 
// // //         year: 'numeric', 
// // //         month: '2-digit', 
// // //         day: '2-digit' 
// // //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// // //       // Custom sorting logic
// // //       sortableData.sort((a, b) => {
// // //         const isUnassignedA = a.Status === null || a.Status === undefined;
// // //         const isUnassignedB = b.Status === null || b.Status === undefined;
// // //         const timeA = a.Received_Date_EST;
// // //         const timeB = b.Received_Date_EST;
// // //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// // //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// // //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// // //         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
// // //           return -1;
// // //         }
// // //         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
// // //           return 1;
// // //         }

// // //         // Step 2: Leads with FollowUpDate date as today (EST)
// // //         if (followUpA === todayStr && followUpB !== todayStr) return -1;
// // //         if (followUpB === todayStr && followUpA !== todayStr) return 1;

// // //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// // //         const idA = Number(a.LeadACVLRecordID || 0);
// // //         const idB = Number(b.LeadACVLRecordID || 0);
// // //         return idB - idA;
// // //       });
// // //     } else if (sortConfig.key) {
// // //       sortableData.sort((a, b) => {
// // //         let aVal = a[sortConfig.key];
// // //         let bVal = b[sortConfig.key];
// // //         // Handle null or undefined values
// // //         if (aVal === undefined || aVal === null) return 1;
// // //         if (bVal === undefined || bVal === null) return -1;
// // //         // Handle LeadACVLRecordID specifically as a number
// // //         if (sortConfig.key === "LeadACVLRecordID") {
// // //           aVal = Number(aVal);
// // //           bVal = Number(bVal);
// // //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // //         }
// // //         // Handle date fields
// // //         const isDateField = [
// // //           "Move_Date",
// // //           "Received_Date_EST",
// // //           "Received_Time_IST",
// // //           "FollowUpDate",
// // //         ].includes(sortConfig.key);
// // //         if (isDateField) {
// // //           const dateA = new Date(aVal);
// // //           const dateB = new Date(bVal);
// // //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// // //         }
// // //         // Handle string fields
// // //         if (typeof aVal === "string" && typeof bVal === "string") {
// // //           return sortConfig.direction === "ascending"
// // //             ? aVal.localeCompare(bVal)
// // //             : bVal.localeCompare(bVal);
// // //         }
// // //         // Handle numeric fields
// // //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // //       });
// // //     }
// // //     return sortableData;
// // //   }, [filteredData, sortConfig, isDefaultSort]);

// // //   const notesByLead = React.useMemo(() => {
// // //     const map = {};
// // //     allNotes.forEach((note) => {
// // //       const id = note.LeadACVLRecordID;
// // //       if (id) {
// // //         if (!map[id]) {
// // //           map[id] = { notes: [], latestByCategory: {} };
// // //         }
// // //         map[id].notes.push(note);
// // //       }
// // //     });
// // //     Object.keys(map).forEach((leadId) => {
// // //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// // //       const categoryMap = {};
// // //       map[leadId].notes.forEach((note) => {
// // //         const category = note.Category?.toLowerCase() || "";
// // //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// // //           categoryMap[category] = note;
// // //         }
// // //       });
// // //       map[leadId].latestByCategory = categoryMap;
// // //     });
// // //     return map;
// // //   }, [allNotes]);

// // //   const startResizing = (e) => {
// // //     isResizing.current = true;
// // //     document.addEventListener("mousemove", resize);
// // //     document.addEventListener("mouseup", stopResizing);
// // //   };

// // //   const resize = (e) => {
// // //     if (!isResizing.current) return;
// // //     const minWidth = 500;
// // //     const maxWidth = window.innerWidth * 0.7;
// // //     let newWidth = window.innerWidth - e.clientX;
// // //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// // //       setWidth(newWidth);
// // //     }
// // //   };

// // //   const stopResizing = () => {
// // //     isResizing.current = false;
// // //     document.removeEventListener("mousemove", resize);
// // //     document.removeEventListener("mouseup", stopResizing);
// // //   };

// // //   useEffect(() => {
// // //     const handleClickOutside = (event) => {
// // //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// // //         setShowFilter(false);
// // //       }
// // //     };
// // //     document.addEventListener("mousedown", handleClickOutside);
// // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // //   }, []);

// // //   const handleColumnChange = (event) => {
// // //     const value = event.target.value;
// // //     setSelectedColumns((prev) =>
// // //       prev.includes(value)
// // //         ? prev.filter((col) => col !== value)
// // //         : prev.length < 7
// // //         ? [...prev, value]
// // //         : prev
// // //     );
// // //   };

// // //   const today = new Date().toISOString().split('T')[0];

// // //   return (
// // //     <div>
// // //       <>
// // //         <TimelineComponent
// // //           userDetails={userDetails}
// // //           accessToken={accessToken}
// // //           onSearchChange={handleSearchChange}
// // //           onGlobalSearch={handleGlobalSearch}
// // //           connectionStatus={connectionStatus}
// // //           onShowReports={() => setShowReports(true)}
// // //         />
// // //       </>
// // //       {showReports && (
// // //         <>
// // //           <button onClick={() => setShowReports(false)}>✖ Close Report</button>
// // //           <Reports />
// // //         </>
// // //       )}
// // //       {!showReports && (
// // //         <div className="table-container">
// // //           <div
// // //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// // //             style={{ flex: selectedBooking ? "1" : "2" }}
// // //           >
// // //             <div>
// // //               <div className="bookings-header-my">
// // //                 <span
// // //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// // //                   onClick={() => handleSort("LeadACVLRecordID")}
// // //                   style={{ cursor: "pointer" }}
// // //                 >
// // //                   ACVL LeadID
// // //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// // //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // //                 </span>
// // //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // //                   (colKey) => {
// // //                     const column = allColumns.find((c) => c.key === colKey);
// // //                     const isSorted = sortConfig.key === colKey;
// // //                     return column ? (
// // //                       <span
// // //                         key={colKey}
// // //                         className="sortable-header"
// // //                         onClick={() => handleSort(colKey)}
// // //                         style={{ cursor: "pointer" }}
// // //                       >
// // //                         {column.label}
// // //                         {!isDefaultSort && isSorted &&
// // //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // //                       </span>
// // //                     ) : null;
// // //                   }
// // //                 )}
// // //                 <span2>
// // //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// // //                     <div>
// // //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// // //                     </div>
// // //                     <div>
// // //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// // //                     </div>
// // //                     <div>
// // //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// // //                     </div>
// // //                     <div>
// // //                       <Search
// // //                         className="filter-icon"
// // //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// // //                         title="Advanced column search"
// // //                       />
// // //                     </div>
// // //                   </div>
// // //                 </span2>
// // //                 {showFilter && (
// // //                   <div className="filter-dropdown" ref={filterRef}>
// // //                     {allColumns.map((col) => (
// // //                       <label key={col.key}>
// // //                         <input
// // //                           type="checkbox"
// // //                           value={col.key}
// // //                           checked={selectedColumns.includes(col.key)}
// // //                           onChange={handleColumnChange}
// // //                           disabled={
// // //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// // //                           }
// // //                         />
// // //                         {col.label}
// // //                       </label>
// // //                     ))}
// // //                   </div>
// // //                 )}
// // //               </div>
// // //               {showAdvancedFilter && (
// // //                 <div className="column-filter-row">
// // //                   <span className="filter-input">
// // //                     <input
// // //                       placeholder="Lead ID"
// // //                       value={columnFilters["LeadACVLRecordID"] || ""}
// // //                       onChange={(e) =>
// // //                         setColumnFilters({
// // //                           ...columnFilters,
// // //                           LeadACVLRecordID: e.target.value,
// // //                         })
// // //                       }
// // //                     />
// // //                   </span>
// // //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // //                     (colKey) => (
// // //                       <span key={colKey} className="filter-input">
// // //                         <input
// // //                           placeholder={
// // //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// // //                           }
// // //                           value={columnFilters[colKey] || ""}
// // //                           onChange={(e) =>
// // //                             setColumnFilters({
// // //                               ...columnFilters,
// // //                               [colKey]: e.target.value,
// // //                             })
// // //                           }
// // //                         />
// // //                       </span>
// // //                     )
// // //                   )}
// // //                   <span className="filter-icons-space" />
// // //                 </div>
// // //               )}
// // //               {loading && <p>Loading...</p>}
// // //               {error && <p className="error">{error}</p>}
// // //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// // //               {!loading &&
// // //                 !error &&
// // //                 sortedData.map((item, index) => {
// // //                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // //                   const categories = leadNotesData.latestByCategory;
// // //                   let flags = [];
// // //                   const now = new Date();
// // //                   const todayStr = now.toLocaleString('en-CA', { 
// // //                     timeZone: 'America/Toronto', 
// // //                     year: 'numeric', 
// // //                     month: '2-digit', 
// // //                     day: '2-digit' 
// // //                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// // //                   const isUnassignedToday =
// // //                     (item.Status === null || item.Status === undefined) &&
// // //                     item.Received_Date_EST &&
// // //                     item.Received_Date_EST.split(' ')[0] === todayStr;
// // //                   const isUnassignedall =
// // //                     (item.Status === null || item.Status === undefined) &&
// // //                     item.Received_Date_EST &&
// // //                     item.Received_Date_EST.split(' ')[0] !== todayStr;
// // //                   let isTodayFollowUp = false;

// // //                   // Collect and process follow-up dates
// // //                   const followUpDates = [];
                  
// // //                   // Add follow-up date from notes (next follow-up category)
// // //                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // //                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// // //                     if (noteDate) {
// // //                       followUpDates.push(noteDate);
// // //                     }
// // //                   }

// // //                   // Add follow-up date from item.FollowUpDate
// // //                   if (item.FollowUpDate) {
// // //                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// // //                     if (itemDate && !followUpDates.includes(itemDate)) {
// // //                       followUpDates.push(itemDate);
// // //                     }
// // //                   }

// // //                   // Select the most relevant follow-up date
// // //                   let selectedFollowUpDate = null;
// // //                   if (followUpDates.length > 0) {
// // //                     // Prioritize: today's date, then past date, then future date
// // //                     const today = new Date(todayStr);
// // //                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// // //                       const followUpDate = new Date(dateStr);
// // //                       if (!selected) return dateStr;
// // //                       const selectedDate = new Date(selected);
// // //                       if (dateStr === todayStr) return dateStr; // Prioritize today's date
// // //                       if (selected === todayStr) return selected;
// // //                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// // //                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// // //                       return selected; // Keep first date if no priority
// // //                     }, null);

// // //                     if (selectedFollowUpDate) {
// // //                       const followUpDate = new Date(selectedFollowUpDate);
// // //                       isTodayFollowUp = selectedFollowUpDate === todayStr;
// // //                       let color;
// // //                       if (followUpDate < today && !isTodayFollowUp) {
// // //                         color = "red"; // Past date
// // //                       } else if (isTodayFollowUp) {
// // //                         color = "green"; // Today
// // //                       } else {
// // //                         color = "gray"; // Future date
// // //                       }
// // //                       flags.push({ 
// // //                         icon: Clock, 
// // //                         color, 
// // //                         title: `Follow-Up: ${selectedFollowUpDate}` 
// // //                       });
// // //                     }
// // //                   }

// // //                   // Process other categories
// // //                   Object.values(categories).forEach((note) => {
// // //                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// // //                       const category = note.Category?.toLowerCase() || "";
// // //                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // //                       if (category === "connection status") {
// // //                         if (categoryDetails === "connected") {
// // //                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // //                         } else if (categoryDetails === "not connected") {
// // //                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // //                         }
// // //                       } else if (category === "prospective") {
// // //                         if (categoryDetails === "hot") {
// // //                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // //                         } else if (categoryDetails === "warm") {
// // //                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // //                         } else if (categoryDetails === "cold") {
// // //                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // //                         }
// // //                       }
// // //                     }
// // //                   });

// // //                   // Process Lead_Priority for left side icon
// // //                   let priorityFlag = null;
// // //                   if (item.Lead_Priority) {
// // //                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
// // //                     let color, title;
// // //                     if (priority === "high") {
// // //                       color = "red";
// // //                       title = "High";
// // //                     } else if (priority === "medium") {
// // //                       color = "purple";
// // //                       title = "Medium";
// // //                     } else if (priority === "low") {
// // //                       color = "green";
// // //                       title = "Low";
// // //                     }
// // //                     if (color && title) {
// // //                       priorityFlag = { icon: Circle, color, title };
// // //                     }
// // //                   }

// // //                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // //                   const orderedFlags = new Array(5).fill(null);
// // //                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // //                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // //                   }
// // //                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // //                     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // //                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // //                     } else {
// // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // //                     }
// // //                   }
// // //                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // //                   if (prospectiveFlag) {
// // //                     orderedFlags[2] = prospectiveFlag;
// // //                   }
// // //                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // //                   if (connectionFlag) {
// // //                     orderedFlags[3] = connectionFlag;
// // //                   }
// // //                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // //                   if (followUpFlag) {
// // //                     orderedFlags[4] = followUpFlag;
// // //                   }

// // //                   return (
// // //                     <div
// // //                       key={index}
// // //                       className={`booking-item-my ${
// // //                         selectedBooking === item ? "active-booking" : ""
// // //                       } ${
// // //                         item.Duplicate_Lead_Details &&
// // //                         Object.keys(item.Duplicate_Lead_Details).length > 0
// // //                           ? "duplicate-item"
// // //                           : ""
// // //                       } ${
// // //                         item.Lead_Source_Status?.toLowerCase() === "return"
// // //                           ? "returned-item"
// // //                           : ""
// // //                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // //                       onClick={() => {
// // //                         if (!selectedBooking) setWidth(700);
// // //                         setSelectedBooking(item);
// // //                       }}
// // //                       style={{
// // //                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // //                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // //                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // //                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // //                       }}
// // //                     >
// // //                       {priorityFlag && (
// // //                         <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
// // //                           <>
// // //                             <priorityFlag.icon
// // //                               className="icon"
// // //                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
// // //                               fill={priorityFlag.color}
// // //                               title={priorityFlag.title}
// // //                             />
// // //                             <div className="custom-tooltip1">
// // //                               {priorityFlag.title}
// // //                             </div>
// // //                           </>
// // //                         </div>
// // //                       )}
// // //                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // //                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // //                         (colKey) => (
// // //                           <span1 key={colKey}>
// // //                             {colKey === "AssignedUserID"
// // //                               ? userMap[item.AssignedUserID] || "N/A"
// // //                               : colKey === "FollowUpDate"
// // //                               ? formatFollowUpDate(item[colKey])
// // //                               : item[colKey] || "N/A"}
// // //                           </span1>
// // //                         )
// // //                       )}
// // //                       <span2 style={{
// // //                         display: "flex",
// // //                         gap: "8px",
// // //                         alignItems: "center",
// // //                         justifyContent: "flex-end",
// // //                         width: "120px",
// // //                       }}>
// // //                         {orderedFlags.map((flag, idx) => (
// // //                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // //                             {flag && (
// // //                               <>
// // //                                 <flag.icon
// // //                                   className="icon"
// // //                                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // //                                   title={flag.title}
// // //                                 />
// // //                                 <div className="custom-tooltip">
// // //                                   {flag.title}
// // //                                 </div>
// // //                               </>
// // //                             )}
// // //                           </div>
// // //                         ))}
// // //                       </span2>
// // //                     </div>
// // //                   );
// // //                 })}
// // //             </div>
// // //           </div>
// // //           {selectedBooking && (
// // //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// // //               <div className="resize-handle" onMouseDown={startResizing}></div>
// // //               <LeadDetails
// // //                 key={selectedBooking.LeadACVLRecordID}
// // //                 booking={selectedBooking}
// // //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// // //                 onClose={() => setSelectedBooking(null)}
// // //                 userDetails={userDetails}
// // //                 accessToken={accessToken}
// // //                 userMap={userMap}
// // //                 updateLeadData={updateLeadData}
// // //                 refetchNotes={refetchNotes}
// // //               />
// // //             </div>
// // //           )}
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default Homepage;

// // // // // commanded the Lead_Priority

// // // // import React, { useState, useEffect, useRef } from "react";
// // // // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle } from "lucide-react";
// // // // import LeadDetails from "./Leaddetails";
// // // // import TimelineComponent from "./Header";
// // // // import Reports from "./Reports";

// // // // const allColumns = [
// // // //   { key: "Sales_Agent", label: "Sales Agent" },
// // // //   { key: "Customer_Name", label: "Lead Name" },
// // // //   { key: "Move_Date", label: "Move Date" },
// // // //   { key: "Status", label: "Estimate Status" },
// // // //   { key: "OriginCity", label: "From Province" },
// // // //   { key: "DestinationCity", label: "To Province" },
// // // //   { key: "FollowUpDate", label: "Follow Up Date" },
// // // //   { key: "Move_Size", label: "Move Size" },
// // // //   { key: "Lead_Status", label: "Lead Status" },
// // // //   { key: "Move_Type", label: "Move Type" },
// // // //   { key: "Estimate_Amount", label: "Estimate Amount" },
// // // //   { key: "From_Postcode", label: "From Postcode" },
// // // //   { key: "To_Postcode", label: "To Postcode" },
// // // //   { key: "Received_Date_EST", label: "Received Date EST" },
// // // //   { key: "Banner", label: "Banner" },
// // // //   { key: "Lead_Source", label: "Lead Source" },
// // // //   { key: "Received_Time_IST", label: "Received Time IST" },
// // // // ];

// // // // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// // // //   const [showReports, setShowReports] = useState(false);
// // // //   const [data, setData] = useState([]);
// // // //   const [filteredData, setFilteredData] = useState([]);
// // // //   const [searchQuery, setSearchQuery] = useState("");
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [error, setError] = useState(null);
// // // //   const [selectedBooking, setSelectedBooking] = useState(null);
// // // //   const [width, setWidth] = useState(350);
// // // //   const [showFilter, setShowFilter] = useState(false);
// // // //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// // // //   const [columnFilters, setColumnFilters] = useState({});
// // // //   const [selectedColumns, setSelectedColumns] = useState(
// // // //     allColumns.slice(0, 7).map((col) => col.key)
// // // //   );
// // // //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// // // //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// // // //   const filterRef = useRef(null);
// // // //   const isResizing = useRef(false);
// // // //   const [userMap, setUserMap] = useState({});
// // // //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// // // //   const prevSelectedLeadId = useRef(null);
// // // //   const [allNotes, setAllNotes] = useState([]);

// // // //   const updateLeadData = (updatedBooking) => {
// // // //     setData((prevData) =>
// // // //       prevData.map((lead) =>
// // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // //           ? { ...lead, ...updatedBooking }
// // // //           : lead
// // // //       )
// // // //     );
// // // //     setFilteredData((prevFilteredData) =>
// // // //       prevFilteredData.map((lead) =>
// // // //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // //           ? { ...lead, ...updatedBooking }
// // // //           : lead
// // // //       )
// // // //     );
// // // //     if (
// // // //       selectedBooking &&
// // // //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// // // //     ) {
// // // //       setSelectedBooking(updatedBooking);
// // // //     }
// // // //   };

// // // //   const refetchNotes = () => {
// // // //     fetchAllNotes();
// // // //   };

// // // //   const formatFollowUpDate = (date) => {
// // // //     if (!date) return "N/A";
// // // //     return date.replace("T", " ");
// // // //   };

// // // //   const handleDefaultSort = () => {
// // // //     setSearchQuery("");
// // // //     setColumnFilters({});
// // // //     setIsGlobalSearch(false);
// // // //     setIsDefaultSort(true);
// // // //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// // // //     fetchLeads();
// // // //   };

// // // //   useEffect(() => {
// // // //     const fetchUserData = async () => {
// // // //       try {
// // // //         const response = await fetch(
// // // //           "https://salesjet-10097049716.catalystappsail.com/userdata",
// // // //           {
// // // //             method: "GET",
// // // //             headers: {
// // // //               Authorization: `Bearer ${accessToken}`,
// // // //               "Content-Type": "application/json",
// // // //             },
// // // //           }
// // // //         );
// // // //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // //         const result = await response.json();
// // // //         const userMapping = result.data.reduce((acc, user) => {
// // // //           acc[user.userId] = user.pseudoname;
// // // //           return acc;
// // // //         }, {});
// // // //         setUserMap(userMapping);
// // // //       } catch (err) {
// // // //         console.error("Error fetching user data:", err.message);
// // // //       }
// // // //     };
// // // //     fetchUserData();
// // // //   }, [accessToken]);

// // // //   const fetchLeads = async () => {
// // // //     try {
// // // //       setLoading(true);
// // // //       const response = await fetch(
// // // //         "https://salesjet-10097049716.catalystappsail.com/leadsdata",
// // // //         {
// // // //           method: "GET",
// // // //           headers: {
// // // //             Authorization: `Bearer ${accessToken}`,
// // // //             "Content-Type": "application/json",
// // // //           },
// // // //         }
// // // //       );
// // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // //       const result = await response.json();
// // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // //       setData(leads);
// // // //       setFilteredData(leads);
// // // //     } catch (err) {
// // // //       setError(err.message);
// // // //       console.error("Error fetching leads:", err.message);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   const fetchAllNotes = async () => {
// // // //     try {
// // // //       const response = await fetch(
// // // //         "https://salesjet-10097049716.catalystappsail.com/allleadnotes",
// // // //         {
// // // //           method: "GET",
// // // //           headers: {
// // // //             Authorization: `Bearer ${accessToken}`,
// // // //             "Content-Type": "application/json",
// // // //           },
// // // //         }
// // // //       );
// // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // //       const result = await response.json();
// // // //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// // // //     } catch (err) {
// // // //       console.error("Error fetching all lead notes:", err.message);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     if (!isGlobalSearch) {
// // // //       fetchLeads();
// // // //       fetchAllNotes();
// // // //     }
// // // //   }, [accessToken, isGlobalSearch]);

// // // //   // Apply default sort on component mount
// // // //   useEffect(() => {
// // // //     handleDefaultSort();
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// // // //       prevSelectedLeadId.current = selectedLeadId;
// // // //       setIsGlobalSearch(true);
// // // //       setColumnFilters({});
// // // //       handleGlobalSearch(selectedLeadId.toString());
// // // //     }
// // // //   }, [selectedLeadId]);

// // // //   useEffect(() => {
// // // //     if (selectedLeadId && filteredData.length > 0) {
// // // //       const matchingLead = filteredData.find(
// // // //         (lead) =>
// // // //           lead.LeadACVLRecordID &&
// // // //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// // // //       );
// // // //       if (matchingLead) {
// // // //         setSelectedBooking(matchingLead);
// // // //         setWidth(700);
// // // //       } else {
// // // //         setSelectedBooking(null);
// // // //       }
// // // //     } else if (selectedLeadId && filteredData.length === 0) {
// // // //       setSelectedBooking(null);
// // // //     }
// // // //   }, [filteredData, selectedLeadId]);

// // // //   useEffect(() => {
// // // //     if (isGlobalSearch) {
// // // //       return;
// // // //     }
// // // //     let filtered = [...data];
// // // //     if (searchQuery.trim()) {
// // // //       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // //       filtered = filtered.filter((lead) =>
// // // //         Object.entries(lead).some(([key, value]) => {
// // // //           if (!value) return false;
// // // //           const normalizedValue = value
// // // //             .toString()
// // // //             .replace(/[^a-zA-Z0-9]/g, "")
// // // //             .toLowerCase();
// // // //           return normalizedValue.includes(normalizedQuery);
// // // //         })
// // // //       );
// // // //     }
// // // //     Object.keys(columnFilters).forEach((key) => {
// // // //       const rawFilter = columnFilters[key];
// // // //       if (rawFilter) {
// // // //         const trimmedRawFilter = rawFilter.trim();
// // // //         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // //         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
// // // //         if (isNAFilter) {
// // // //           filtered = filtered.filter((lead) => {
// // // //             const value = lead[key];
// // // //             return value === null || value === undefined || value === "" || value === "N/A";
// // // //           });
// // // //         } else if (normalizedFilter) {
// // // //           filtered = filtered.filter((lead) => {
// // // //             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // //             return value?.includes(normalizedFilter);
// // // //           });
// // // //         }
// // // //       }
// // // //     });
// // // //     setFilteredData(filtered);
// // // //   }, [data, searchQuery, columnFilters, isGlobalSearch]);

// // // //   const handleSearchChange = (query) => {
// // // //     setSearchQuery(query);
// // // //     setIsGlobalSearch(false);
// // // //     setColumnFilters({});
// // // //   };

// // // //   const handleGlobalSearch = async (query) => {
// // // //     setLoading(true);
// // // //     setIsDefaultSort(false);
// // // //     setIsGlobalSearch(true);
// // // //     try {
// // // //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// // // //       const response = await fetch(
// // // //         "https://salesjet-10097049716.catalystappsail.com/globalsearch",
// // // //         {
// // // //           method: "POST",
// // // //           headers: {
// // // //             Authorization: `Bearer ${accessToken}`,
// // // //             "Content-Type": "application/json",
// // // //           },
// // // //           body: JSON.stringify({ query: normalizedQuery }),
// // // //         }
// // // //       );
// // // //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// // // //       const result = await response.json();
// // // //       const leads = Array.isArray(result.data) ? result.data : [];
// // // //       setFilteredData(leads);
// // // //       setSearchQuery(query);
// // // //       fetchAllNotes();
// // // //     } catch (err) {
// // // //       console.error("Global search error:", err.message);
// // // //       setError(err.message);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   const handleSort = (key) => {
// // // //     setIsDefaultSort(false);
// // // //     setSortConfig((prev) =>
// // // //       prev.key === key
// // // //         ? {
// // // //             key,
// // // //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// // // //           }
// // // //         : { key, direction: "ascending" }
// // // //     );
// // // //   };

// // // //   const sortedData = React.useMemo(() => {
// // // //     let sortableData = [...filteredData];
// // // //     if (isDefaultSort) {
// // // //       // Get current date in EST (America/Toronto)
// // // //       const now = new Date();
// // // //       const todayStr = now.toLocaleString('en-CA', { 
// // // //         timeZone: 'America/Toronto', 
// // // //         year: 'numeric', 
// // // //         month: '2-digit', 
// // // //         day: '2-digit' 
// // // //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// // // //       // Custom sorting logic
// // // //       sortableData.sort((a, b) => {
// // // //         const isUnassignedA = a.Status === null || a.Status === undefined;
// // // //         const isUnassignedB = b.Status === null || b.Status === undefined;
// // // //         const timeA = a.Received_Date_EST;
// // // //         const timeB = b.Received_Date_EST;
// // // //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// // // //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// // // //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// // // //         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
// // // //           return -1;
// // // //         }
// // // //         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
// // // //           return 1;
// // // //         }

// // // //         // Step 2: Leads with FollowUpDate date as today (EST)
// // // //         if (followUpA === todayStr && followUpB !== todayStr) return -1;
// // // //         if (followUpB === todayStr && followUpA !== todayStr) return 1;

// // // //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// // // //         const idA = Number(a.LeadACVLRecordID || 0);
// // // //         const idB = Number(b.LeadACVLRecordID || 0);
// // // //         return idB - idA;
// // // //       });
// // // //     } else if (sortConfig.key) {
// // // //       sortableData.sort((a, b) => {
// // // //         let aVal = a[sortConfig.key];
// // // //         let bVal = b[sortConfig.key];
// // // //         // Handle null or undefined values
// // // //         if (aVal === undefined || aVal === null) return 1;
// // // //         if (bVal === undefined || bVal === null) return -1;
// // // //         // Handle LeadACVLRecordID specifically as a number
// // // //         if (sortConfig.key === "LeadACVLRecordID") {
// // // //           aVal = Number(aVal);
// // // //           bVal = Number(bVal);
// // // //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // //         }
// // // //         // Handle date fields
// // // //         const isDateField = [
// // // //           "Move_Date",
// // // //           "Received_Date_EST",
// // // //           "Received_Time_IST",
// // // //           "FollowUpDate",
// // // //         ].includes(sortConfig.key);
// // // //         if (isDateField) {
// // // //           const dateA = new Date(aVal);
// // // //           const dateB = new Date(bVal);
// // // //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// // // //         }
// // // //         // Handle string fields
// // // //         if (typeof aVal === "string" && typeof bVal === "string") {
// // // //           return sortConfig.direction === "ascending"
// // // //             ? aVal.localeCompare(bVal)
// // // //             : bVal.localeCompare(bVal);
// // // //         }
// // // //         // Handle numeric fields
// // // //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// // // //       });
// // // //     }
// // // //     return sortableData;
// // // //   }, [filteredData, sortConfig, isDefaultSort]);

// // // //   const notesByLead = React.useMemo(() => {
// // // //     const map = {};
// // // //     allNotes.forEach((note) => {
// // // //       const id = note.LeadACVLRecordID;
// // // //       if (id) {
// // // //         if (!map[id]) {
// // // //           map[id] = { notes: [], latestByCategory: {} };
// // // //         }
// // // //         map[id].notes.push(note);
// // // //       }
// // // //     });
// // // //     Object.keys(map).forEach((leadId) => {
// // // //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// // // //       const categoryMap = {};
// // // //       map[leadId].notes.forEach((note) => {
// // // //         const category = note.Category?.toLowerCase() || "";
// // // //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// // // //           categoryMap[category] = note;
// // // //         }
// // // //       });
// // // //       map[leadId].latestByCategory = categoryMap;
// // // //     });
// // // //     return map;
// // // //   }, [allNotes]);

// // // //   const startResizing = (e) => {
// // // //     isResizing.current = true;
// // // //     document.addEventListener("mousemove", resize);
// // // //     document.addEventListener("mouseup", stopResizing);
// // // //   };

// // // //   const resize = (e) => {
// // // //     if (!isResizing.current) return;
// // // //     const minWidth = 500;
// // // //     const maxWidth = window.innerWidth * 0.7;
// // // //     let newWidth = window.innerWidth - e.clientX;
// // // //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// // // //       setWidth(newWidth);
// // // //     }
// // // //   };

// // // //   const stopResizing = () => {
// // // //     isResizing.current = false;
// // // //     document.removeEventListener("mousemove", resize);
// // // //     document.removeEventListener("mouseup", stopResizing);
// // // //   };

// // // //   useEffect(() => {
// // // //     const handleClickOutside = (event) => {
// // // //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// // // //         setShowFilter(false);
// // // //       }
// // // //     };
// // // //     document.addEventListener("mousedown", handleClickOutside);
// // // //     return () => document.removeEventListener("mousedown", handleClickOutside);
// // // //   }, []);

// // // //   const handleColumnChange = (event) => {
// // // //     const value = event.target.value;
// // // //     setSelectedColumns((prev) =>
// // // //       prev.includes(value)
// // // //         ? prev.filter((col) => col !== value)
// // // //         : prev.length < 7
// // // //         ? [...prev, value]
// // // //         : prev
// // // //     );
// // // //   };

// // // //   const today = new Date().toISOString().split('T')[0];

// // // //   return (
// // // //     <div>
// // // //       <>
// // // //         <TimelineComponent
// // // //           userDetails={userDetails}
// // // //           accessToken={accessToken}
// // // //           onSearchChange={handleSearchChange}
// // // //           onGlobalSearch={handleGlobalSearch}
// // // //           connectionStatus={connectionStatus}
// // // //           onShowReports={() => setShowReports(true)}
// // // //         />
// // // //       </>
// // // //       {showReports && (
// // // //         <>
// // // //           <button onClick={() => setShowReports(false)}>✖ Close Report</button>
// // // //           <Reports />
// // // //         </>
// // // //       )}
// // // //       {!showReports && (
// // // //         <div className="table-container">
// // // //           <div
// // // //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// // // //             style={{ flex: selectedBooking ? "1" : "2" }}
// // // //           >
// // // //             <div>
// // // //               <div className="bookings-header-my">
// // // //                 <span
// // // //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// // // //                   onClick={() => handleSort("LeadACVLRecordID")}
// // // //                   style={{ cursor: "pointer" }}
// // // //                 >
// // // //                   ACVL LeadID
// // // //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// // // //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // //                 </span>
// // // //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // //                   (colKey) => {
// // // //                     const column = allColumns.find((c) => c.key === colKey);
// // // //                     const isSorted = sortConfig.key === colKey;
// // // //                     return column ? (
// // // //                       <span
// // // //                         key={colKey}
// // // //                         className="sortable-header"
// // // //                         onClick={() => handleSort(colKey)}
// // // //                         style={{ cursor: "pointer" }}
// // // //                       >
// // // //                         {column.label}
// // // //                         {!isDefaultSort && isSorted &&
// // // //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// // // //                       </span>
// // // //                     ) : null;
// // // //                   }
// // // //                 )}
// // // //                 <span2>
// // // //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// // // //                     <div>
// // // //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// // // //                     </div>
// // // //                     <div>
// // // //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// // // //                     </div>
// // // //                     <div>
// // // //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// // // //                     </div>
// // // //                     <div>
// // // //                       <Search
// // // //                         className="filter-icon"
// // // //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// // // //                         title="Advanced column search"
// // // //                       />
// // // //                     </div>
// // // //                   </div>
// // // //                 </span2>
// // // //                 {showFilter && (
// // // //                   <div className="filter-dropdown" ref={filterRef}>
// // // //                     {allColumns.map((col) => (
// // // //                       <label key={col.key}>
// // // //                         <input
// // // //                           type="checkbox"
// // // //                           value={col.key}
// // // //                           checked={selectedColumns.includes(col.key)}
// // // //                           onChange={handleColumnChange}
// // // //                           disabled={
// // // //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// // // //                           }
// // // //                         />
// // // //                         {col.label}
// // // //                       </label>
// // // //                     ))}
// // // //                   </div>
// // // //                 )}
// // // //               </div>
// // // //               {showAdvancedFilter && (
// // // //                 <div className="column-filter-row">
// // // //                   <span className="filter-input">
// // // //                     <input
// // // //                       placeholder="Lead ID"
// // // //                       value={columnFilters["LeadACVLRecordID"] || ""}
// // // //                       onChange={(e) =>
// // // //                         setColumnFilters({
// // // //                           ...columnFilters,
// // // //                           LeadACVLRecordID: e.target.value,
// // // //                         })
// // // //                       }
// // // //                     />
// // // //                   </span>
// // // //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // //                     (colKey) => (
// // // //                       <span key={colKey} className="filter-input">
// // // //                         <input
// // // //                           placeholder={
// // // //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// // // //                           }
// // // //                           value={columnFilters[colKey] || ""}
// // // //                           onChange={(e) =>
// // // //                             setColumnFilters({
// // // //                               ...columnFilters,
// // // //                               [colKey]: e.target.value,
// // // //                             })
// // // //                           }
// // // //                         />
// // // //                       </span>
// // // //                     )
// // // //                   )}
// // // //                   <span className="filter-icons-space" />
// // // //                 </div>
// // // //               )}
// // // //               {loading && <p>Loading...</p>}
// // // //               {error && <p className="error">{error}</p>}
// // // //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// // // //               {!loading &&
// // // //                 !error &&
// // // //                 sortedData.map((item, index) => {
// // // //                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// // // //                   const categories = leadNotesData.latestByCategory;
// // // //                   let flags = [];
// // // //                   const now = new Date();
// // // //                   const todayStr = now.toLocaleString('en-CA', { 
// // // //                     timeZone: 'America/Toronto', 
// // // //                     year: 'numeric', 
// // // //                     month: '2-digit', 
// // // //                     day: '2-digit' 
// // // //                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// // // //                   const isUnassignedToday =
// // // //                     (item.Status === null || item.Status === undefined) &&
// // // //                     item.Received_Date_EST &&
// // // //                     item.Received_Date_EST.split(' ')[0] === todayStr;
// // // //                   const isUnassignedall =
// // // //                     (item.Status === null || item.Status === undefined) &&
// // // //                     item.Received_Date_EST &&
// // // //                     item.Received_Date_EST.split(' ')[0] !== todayStr;
// // // //                   let isTodayFollowUp = false;

// // // //                   // Collect and process follow-up dates
// // // //                   const followUpDates = [];
                  
// // // //                   // Add follow-up date from notes (next follow-up category)
// // // //                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// // // //                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// // // //                     if (noteDate) {
// // // //                       followUpDates.push(noteDate);
// // // //                     }
// // // //                   }

// // // //                   // Add follow-up date from item.FollowUpDate
// // // //                   if (item.FollowUpDate) {
// // // //                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// // // //                     if (itemDate && !followUpDates.includes(itemDate)) {
// // // //                       followUpDates.push(itemDate);
// // // //                     }
// // // //                   }

// // // //                   // Select the most relevant follow-up date
// // // //                   let selectedFollowUpDate = null;
// // // //                   if (followUpDates.length > 0) {
// // // //                     // Prioritize: today's date, then past date, then future date
// // // //                     const today = new Date(todayStr);
// // // //                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// // // //                       const followUpDate = new Date(dateStr);
// // // //                       if (!selected) return dateStr;
// // // //                       const selectedDate = new Date(selected);
// // // //                       if (dateStr === todayStr) return dateStr; // Prioritize today's date
// // // //                       if (selected === todayStr) return selected;
// // // //                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// // // //                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// // // //                       return selected; // Keep first date if no priority
// // // //                     }, null);

// // // //                     if (selectedFollowUpDate) {
// // // //                       const followUpDate = new Date(selectedFollowUpDate);
// // // //                       isTodayFollowUp = selectedFollowUpDate === todayStr;
// // // //                       let color;
// // // //                       if (followUpDate < today && !isTodayFollowUp) {
// // // //                         color = "red"; // Past date
// // // //                       } else if (isTodayFollowUp) {
// // // //                         color = "green"; // Today
// // // //                       } else {
// // // //                         color = "gray"; // Future date
// // // //                       }
// // // //                       flags.push({ 
// // // //                         icon: Clock, 
// // // //                         color, 
// // // //                         title: `Follow-Up: ${selectedFollowUpDate}` 
// // // //                       });
// // // //                     }
// // // //                   }

// // // //                   // Process other categories
// // // //                   Object.values(categories).forEach((note) => {
// // // //                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// // // //                       const category = note.Category?.toLowerCase() || "";
// // // //                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// // // //                       if (category === "connection status") {
// // // //                         if (categoryDetails === "connected") {
// // // //                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// // // //                         } else if (categoryDetails === "not connected") {
// // // //                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// // // //                         }
// // // //                       } else if (category === "prospective") {
// // // //                         if (categoryDetails === "hot") {
// // // //                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// // // //                         } else if (categoryDetails === "warm") {
// // // //                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// // // //                         } else if (categoryDetails === "cold") {
// // // //                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// // // //                         }
// // // //                       }
// // // //                     }
// // // //                   });

// // // //                   // Process Lead_Priority for left side icon
// // // //                   /*
// // // //                   let priorityFlag = null;
// // // //                   if (item.Lead_Priority) {
// // // //                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
// // // //                     let color, title;
// // // //                     if (priority === "high") {
// // // //                       color = "red";
// // // //                       title = "High";
// // // //                     } else if (priority === "medium") {
// // // //                       color = "purple";
// // // //                       title = "Medium";
// // // //                     } else if (priority === "low") {
// // // //                       color = "green";
// // // //                       title = "Low";
// // // //                     }
// // // //                     if (color && title) {
// // // //                       priorityFlag = { icon: Circle, color, title };
// // // //                     }
// // // //                   }
// // // //                   */

// // // //                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// // // //                   const orderedFlags = new Array(5).fill(null);
// // // //                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// // // //                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// // // //                   }
// // // //                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// // // //                     if (item.Return_Outcome?.toLowerCase() === "approved") {
// // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// // // //                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// // // //                     } else {
// // // //                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// // // //                     }
// // // //                   }
// // // //                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// // // //                   if (prospectiveFlag) {
// // // //                     orderedFlags[2] = prospectiveFlag;
// // // //                   }
// // // //                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// // // //                   if (connectionFlag) {
// // // //                     orderedFlags[3] = connectionFlag;
// // // //                   }
// // // //                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// // // //                   if (followUpFlag) {
// // // //                     orderedFlags[4] = followUpFlag;
// // // //                   }

// // // //                   return (
// // // //                     <div
// // // //                       key={index}
// // // //                       className={`booking-item-my ${
// // // //                         selectedBooking === item ? "active-booking" : ""
// // // //                       } ${
// // // //                         item.Duplicate_Lead_Details &&
// // // //                         Object.keys(item.Duplicate_Lead_Details).length > 0
// // // //                           ? "duplicate-item"
// // // //                           : ""
// // // //                       } ${
// // // //                         item.Lead_Source_Status?.toLowerCase() === "return"
// // // //                           ? "returned-item"
// // // //                           : ""
// // // //                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// // // //                       onClick={() => {
// // // //                         if (!selectedBooking) setWidth(700);
// // // //                         setSelectedBooking(item);
// // // //                       }}
// // // //                       style={{
// // // //                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// // // //                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// // // //                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// // // //                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// // // //                       }}
// // // //                     >
// // // //                       {/* {priorityFlag && (
// // // //                         <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
// // // //                           <>
// // // //                             <priorityFlag.icon
// // // //                               className="icon"
// // // //                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
// // // //                               fill={priorityFlag.color}
// // // //                               title={priorityFlag.title}
// // // //                             />
// // // //                             <div className="custom-tooltip1">
// // // //                               {priorityFlag.title}
// // // //                             </div>
// // // //                           </>
// // // //                         </div>
// // // //                       )} */}
// // // //                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// // // //                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// // // //                         (colKey) => (
// // // //                           <span1 key={colKey}>
// // // //                             {colKey === "AssignedUserID"
// // // //                               ? userMap[item.AssignedUserID] || "N/A"
// // // //                               : colKey === "FollowUpDate"
// // // //                               ? formatFollowUpDate(item[colKey])
// // // //                               : item[colKey] || "N/A"}
// // // //                           </span1>
// // // //                         )
// // // //                       )}
// // // //                       <span2 style={{
// // // //                         display: "flex",
// // // //                         gap: "8px",
// // // //                         alignItems: "center",
// // // //                         justifyContent: "flex-end",
// // // //                         width: "120px",
// // // //                       }}>
// // // //                         {orderedFlags.map((flag, idx) => (
// // // //                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// // // //                             {flag && (
// // // //                               <>
// // // //                                 <flag.icon
// // // //                                   className="icon"
// // // //                                   style={{ color: flag.color, width: "16px", height: "16px" }}
// // // //                                   title={flag.title}
// // // //                                 />
// // // //                                 <div className="custom-tooltip">
// // // //                                   {flag.title}
// // // //                                 </div>
// // // //                               </>
// // // //                             )}
// // // //                           </div>
// // // //                         ))}
// // // //                       </span2>
// // // //                     </div>
// // // //                   );
// // // //                 })}
// // // //             </div>
// // // //           </div>
// // // //           {selectedBooking && (
// // // //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// // // //               <div className="resize-handle" onMouseDown={startResizing}></div>
// // // //               <LeadDetails
// // // //                 key={selectedBooking.LeadACVLRecordID}
// // // //                 booking={selectedBooking}
// // // //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// // // //                 onClose={() => setSelectedBooking(null)}
// // // //                 userDetails={userDetails}
// // // //                 accessToken={accessToken}
// // // //                 userMap={userMap}
// // // //                 updateLeadData={updateLeadData}
// // // //                 refetchNotes={refetchNotes}
// // // //               />
// // // //             </div>
// // // //           )}
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Homepage;


// // // changes after header get from local
// // import React, { useState, useEffect, useRef } from "react";
// // import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle } from "lucide-react";
// // import LeadDetails from "./Leaddetails";
// // import TimelineComponent from "./Header";
// // import Reports from "./Reports";

// // const allColumns = [
// //   { key: "Sales_Agent", label: "Sales Agent" },
// //   { key: "Customer_Name", label: "Lead Name" },
// //   { key: "Move_Date", label: "Move Date" },
// //   { key: "Status", label: "Estimate Status" },
// //   { key: "OriginCity", label: "From Province" },
// //   { key: "DestinationCity", label: "To Province" },
// //   { key: "FollowUpDate", label: "Follow Up Date" },
// //   { key: "Move_Size", label: "Move Size" },
// //   { key: "Lead_Status", label: "Lead Status" },
// //   { key: "Move_Type", label: "Move Type" },
// //   { key: "Estimate_Amount", label: "Estimate Amount" },
// //   { key: "From_Postcode", label: "From Postcode" },
// //   { key: "To_Postcode", label: "To Postcode" },
// //   { key: "Received_Date_EST", label: "Received Date EST" },
// //   { key: "Banner", label: "Banner" },
// //   { key: "Lead_Priority", label: "Lead Priority" },
// //   { key: "Received_Time_IST", label: "Received Time IST" },
// // ];

// // const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
// //   const [showReports, setShowReports] = useState(false);
// //   const [data, setData] = useState([]);
// //   const [filteredData, setFilteredData] = useState([]);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [selectedBooking, setSelectedBooking] = useState(null);
// //   const [width, setWidth] = useState(350);
// //   const [showFilter, setShowFilter] = useState(false);
// //   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
// //   const [columnFilters, setColumnFilters] = useState({});
// //   const [selectedColumns, setSelectedColumns] = useState(
// //     allColumns.slice(0, 7).map((col) => col.key)
// //   );
// //   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
// //   const [isDefaultSort, setIsDefaultSort] = useState(false);
// //   const filterRef = useRef(null);
// //   const isResizing = useRef(false);
// //   const [userMap, setUserMap] = useState({});
// //   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
// //   const prevSelectedLeadId = useRef(null);
// //   const [allNotes, setAllNotes] = useState([]);

// //   const updateLeadData = (updatedBooking) => {
// //     setData((prevData) =>
// //       prevData.map((lead) =>
// //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// //           ? { ...lead, ...updatedBooking }
// //           : lead
// //       )
// //     );
// //     setFilteredData((prevFilteredData) =>
// //       prevFilteredData.map((lead) =>
// //         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// //           ? { ...lead, ...updatedBooking }
// //           : lead
// //       )
// //     );
// //     if (
// //       selectedBooking &&
// //       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
// //     ) {
// //       setSelectedBooking(updatedBooking);
// //     }
// //   };

// //   const refetchNotes = () => {
// //     fetchAllNotes();
// //   };

// //   const formatFollowUpDate = (date) => {
// //     if (!date) return "N/A";
// //     return date.replace("T", " ");
// //   };

// //   const handleDefaultSort = () => {
// //     setSearchQuery("");
// //     setColumnFilters({});
// //     setIsGlobalSearch(false);
// //     setIsDefaultSort(true);
// //     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
// //     fetchLeads();
// //   };

// //   const updateUserpreference = async (headers) => {
// //       try {
// //         const payload = { Userpreference: { Header: headers } };
// //         await fetch("https://salesjet-10097049716.catalystappsail.com/userdata", {
// //           method: "PUT",
// //           headers: {
// //             Authorization: `Bearer ${accessToken}`,
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify(payload),
// //         });
// //       } catch (err) {
// //         console.error("Error updating preferences:", err);
// //       }
// //   };

// //   const loadPreferences = () => {
// //     try {
// //       const stored = localStorage.getItem("Userpreference");
// //       let headers;
// //       if (stored) {
// //         const parsed = JSON.parse(stored);
// //         headers = parsed.Headers || null;
// //       }
// //       if (!headers || !Array.isArray(headers) || headers.length === 0) {
// //         headers = allColumns.slice(0, 7).map((col) => col.label);
// //         const prefs = { Headers: headers };
// //         localStorage.setItem("Userpreference", JSON.stringify(prefs));
// //         updateUserpreference(headers);
// //       }
// //       // Map labels to keys
// //       const keys = headers
// //         .map((label) => {
// //           const col = allColumns.find((c) => c.label === label);
// //           return col ? col.key : null;
// //         })
// //         .filter(Boolean);
// //       setSelectedColumns(keys);
// //     } catch (err) {
// //       console.error(err);
// //       // Fallback to default
// //       const headers = allColumns.slice(0, 7).map((col) => col.label);
// //       const prefs = { Headers: headers };
// //       localStorage.setItem("Userpreference", JSON.stringify(prefs));
// //       updateUserpreference(headers);
// //       setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
// //     }
// //   };

// //   useEffect(() => {
// //     if (accessToken) {
// //       loadPreferences();
// //     }
// //   }, [accessToken]);

// //   useEffect(() => {
// //     const fetchUserData = async () => {
// //       try {
// //         const response = await fetch(
// //           "https://salesjet-10097049716.catalystappsail.com/userdata",
// //           {
// //             method: "GET",
// //             headers: {
// //               Authorization: `Bearer ${accessToken}`,
// //               "Content-Type": "application/json",
// //             },
// //           }
// //         );
// //         if (!response.ok) throw new Error(`Error: ${response.status}`);
// //         const result = await response.json();
// //         const userMapping = result.data.reduce((acc, user) => {
// //           acc[user.userId] = user.pseudoname;
// //           return acc;
// //         }, {});
// //         setUserMap(userMapping);
// //       } catch (err) {
// //         console.error("Error fetching user data:", err.message);
// //       }
// //     };
// //     fetchUserData();
// //   }, [accessToken]);

// //   const fetchLeads = async () => {
// //     try {
// //       setLoading(true);
// //       const response = await fetch(
// //         "https://salesjet-10097049716.catalystappsail.com/leadsdata",
// //         {
// //           method: "GET",
// //           headers: {
// //             Authorization: `Bearer ${accessToken}`,
// //             "Content-Type": "application/json",
// //           },
// //         }
// //       );
// //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// //       const result = await response.json();
// //       const leads = Array.isArray(result.data) ? result.data : [];
// //       setData(leads);
// //       setFilteredData(leads);
// //     } catch (err) {
// //       setError(err.message);
// //       console.error("Error fetching leads:", err.message);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const fetchAllNotes = async () => {
// //     try {
// //       const response = await fetch(
// //         "https://salesjet-10097049716.catalystappsail.com/allleadnotes",
// //         {
// //           method: "GET",
// //           headers: {
// //             Authorization: `Bearer ${accessToken}`,
// //             "Content-Type": "application/json",
// //           },
// //         }
// //       );
// //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// //       const result = await response.json();
// //       setAllNotes(Array.isArray(result.data) ? result.data : []);
// //     } catch (err) {
// //       console.error("Error fetching all lead notes:", err.message);
// //     }
// //   };

// //   useEffect(() => {
// //     if (!isGlobalSearch) {
// //       fetchLeads();
// //       fetchAllNotes();
// //     }
// //   }, [accessToken, isGlobalSearch]);

// //   useEffect(() => {
// //     handleDefaultSort();
// //   }, []);

// //   useEffect(() => {
// //     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
// //       prevSelectedLeadId.current = selectedLeadId;
// //       setIsGlobalSearch(true);
// //       setColumnFilters({});
// //       handleGlobalSearch(selectedLeadId.toString());
// //     }
// //   }, [selectedLeadId]);

// //   useEffect(() => {
// //     if (selectedLeadId && filteredData.length > 0) {
// //       const matchingLead = filteredData.find(
// //         (lead) =>
// //           lead.LeadACVLRecordID &&
// //           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
// //       );
// //       if (matchingLead) {
// //         setSelectedBooking(matchingLead);
// //         setWidth(700);
// //       } else {
// //         setSelectedBooking(null);
// //       }
// //     } else if (selectedLeadId && filteredData.length === 0) {
// //       setSelectedBooking(null);
// //     }
// //   }, [filteredData, selectedLeadId]);

// //   useEffect(() => {
// //     if (isGlobalSearch) {
// //       return;
// //     }
// //     let filtered = [...data];
// //     if (searchQuery.trim()) {
// //       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// //       filtered = filtered.filter((lead) =>
// //         Object.entries(lead).some(([key, value]) => {
// //           if (!value) return false;
// //           const normalizedValue = value
// //             .toString()
// //             .replace(/[^a-zA-Z0-9]/g, "")
// //             .toLowerCase();
// //           return normalizedValue.includes(normalizedQuery);
// //         })
// //       );
// //     }
// //     Object.keys(columnFilters).forEach((key) => {
// //       const rawFilter = columnFilters[key];
// //       if (rawFilter) {
// //         const trimmedRawFilter = rawFilter.trim();
// //         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// //         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
// //         if (isNAFilter) {
// //           filtered = filtered.filter((lead) => {
// //             const value = lead[key];
// //             return value === null || value === undefined || value === "" || value === "N/A";
// //           });
// //         } else if (normalizedFilter) {
// //           filtered = filtered.filter((lead) => {
// //             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// //             return value?.includes(normalizedFilter);
// //           });
// //         }
// //       }
// //     });
// //     setFilteredData(filtered);
// //   }, [data, searchQuery, columnFilters, isGlobalSearch]);

// //   const handleSearchChange = (query) => {
// //     setSearchQuery(query);
// //     setIsGlobalSearch(false);
// //     setColumnFilters({});
// //   };

// //   const handleGlobalSearch = async (query) => {
// //     setLoading(true);
// //     setIsDefaultSort(false);
// //     setIsGlobalSearch(true);
// //     try {
// //       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
// //       const response = await fetch(
// //         "https://salesjet-10097049716.catalystappsail.com/globalsearch",
// //         {
// //           method: "POST",
// //           headers: {
// //             Authorization: `Bearer ${accessToken}`,
// //             "Content-Type": "application/json",
// //           },
// //           body: JSON.stringify({ query: normalizedQuery }),
// //         }
// //       );
// //       if (!response.ok) throw new Error(`Error: ${response.status}`);
// //       const result = await response.json();
// //       const leads = Array.isArray(result.data) ? result.data : [];
// //       setFilteredData(leads);
// //       setSearchQuery(query);
// //       fetchAllNotes();
// //     } catch (err) {
// //       console.error("Global search error:", err.message);
// //       setError(err.message);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleSort = (key) => {
// //     setIsDefaultSort(false);
// //     setSortConfig((prev) =>
// //       prev.key === key
// //         ? {
// //             key,
// //             direction: prev.direction === "ascending" ? "descending" : "ascending",
// //           }
// //         : { key, direction: "ascending" }
// //     );
// //   };

// //   const handleColumnChange = (event) => {
// //     const value = event.target.value;
// //     setSelectedColumns((prev) => {
// //       let newSelected;
// //       if (prev.includes(value)) {
// //         newSelected = prev.filter((col) => col !== value);
// //       } else {
// //         newSelected = prev.length < 7 ? [...prev, value] : prev;
// //       }
// //       // Update localStorage and backend
// //       const labels = newSelected.map((key) => {
// //         const col = allColumns.find((c) => c.key === key);
// //         return col ? col.label : "";
// //       });
// //       const prefs = { Headers: labels };
// //       localStorage.setItem("Userpreference", JSON.stringify(prefs));
// //       updateUserpreference(labels);
// //       return newSelected;
// //     });
// //   };

// //   const sortedData = React.useMemo(() => {
// //     let sortableData = [...filteredData];
// //     if (isDefaultSort) {
// //       // Get current date in EST (America/Toronto)
// //       const now = new Date();
// //       const todayStr = now.toLocaleString('en-CA', { 
// //         timeZone: 'America/Toronto', 
// //         year: 'numeric', 
// //         month: '2-digit', 
// //         day: '2-digit' 
// //       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

// //       // Custom sorting logic
// //       sortableData.sort((a, b) => {
// //         const isUnassignedA = a.Status === null || a.Status === undefined;
// //         const isUnassignedB = b.Status === null || b.Status === undefined;
// //         const timeA = a.Received_Date_EST;
// //         const timeB = b.Received_Date_EST;
// //         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
// //         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

// //         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
// //         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
// //           return -1;
// //         }
// //         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
// //           return 1;
// //         }

// //         // Step 2: Leads with FollowUpDate date as today (EST)
// //         if (followUpA === todayStr && followUpB !== todayStr) return -1;
// //         if (followUpB === todayStr && followUpA !== todayStr) return 1;

// //         // Step 3: Sort by LeadACVLRecordID descending as fallback
// //         const idA = Number(a.LeadACVLRecordID || 0);
// //         const idB = Number(b.LeadACVLRecordID || 0);
// //         return idB - idA;
// //       });
// //     } else if (sortConfig.key) {
// //       sortableData.sort((a, b) => {
// //         let aVal = a[sortConfig.key];
// //         let bVal = b[sortConfig.key];
// //         // Handle null or undefined values
// //         if (aVal === undefined || aVal === null) return 1;
// //         if (bVal === undefined || bVal === null) return -1;
// //         // Handle LeadACVLRecordID specifically as a number
// //         if (sortConfig.key === "LeadACVLRecordID") {
// //           aVal = Number(aVal);
// //           bVal = Number(bVal);
// //           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// //         }
// //         // Handle date fields
// //         const isDateField = [
// //           "Move_Date",
// //           "Received_Date_EST",
// //           "Received_Time_IST",
// //           "FollowUpDate",
// //         ].includes(sortConfig.key);
// //         if (isDateField) {
// //           const dateA = new Date(aVal);
// //           const dateB = new Date(bVal);
// //           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
// //         }
// //         // Handle string fields
// //         if (typeof aVal === "string" && typeof bVal === "string") {
// //           return sortConfig.direction === "ascending"
// //             ? aVal.localeCompare(bVal)
// //             : bVal.localeCompare(bVal);
// //         }
// //         // Handle numeric fields
// //         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
// //       });
// //     }
// //     return sortableData;
// //   }, [filteredData, sortConfig, isDefaultSort]);

// //   const notesByLead = React.useMemo(() => {
// //     const map = {};
// //     allNotes.forEach((note) => {
// //       const id = note.LeadACVLRecordID;
// //       if (id) {
// //         if (!map[id]) {
// //           map[id] = { notes: [], latestByCategory: {} };
// //         }
// //         map[id].notes.push(note);
// //       }
// //     });
// //     Object.keys(map).forEach((leadId) => {
// //       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
// //       const categoryMap = {};
// //       map[leadId].notes.forEach((note) => {
// //         const category = note.Category?.toLowerCase() || "";
// //         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
// //           categoryMap[category] = note;
// //         }
// //       });
// //       map[leadId].latestByCategory = categoryMap;
// //     });
// //     return map;
// //   }, [allNotes]);

// //   const startResizing = (e) => {
// //     isResizing.current = true;
// //     document.addEventListener("mousemove", resize);
// //     document.addEventListener("mouseup", stopResizing);
// //   };

// //   const resize = (e) => {
// //     if (!isResizing.current) return;
// //     const minWidth = 500;
// //     const maxWidth = window.innerWidth * 0.7;
// //     let newWidth = window.innerWidth - e.clientX;
// //     if (newWidth >= minWidth && newWidth <= maxWidth) {
// //       setWidth(newWidth);
// //     }
// //   };

// //   const stopResizing = () => {
// //     isResizing.current = false;
// //     document.removeEventListener("mousemove", resize);
// //     document.removeEventListener("mouseup", stopResizing);
// //   };

// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (filterRef.current && !filterRef.current.contains(event.target)) {
// //         setShowFilter(false);
// //       }
// //     };
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => document.removeEventListener("mousedown", handleClickOutside);
// //   }, []);

// //   const today = new Date().toISOString().split('T')[0];

// //   return (
// //     <div>
// //       <>
// //         <TimelineComponent
// //           userDetails={userDetails}
// //           accessToken={accessToken}
// //           onSearchChange={handleSearchChange}
// //           onGlobalSearch={handleGlobalSearch}
// //           connectionStatus={connectionStatus}
// //           onShowReports={() => setShowReports(true)}
// //         />
// //       </>
// //       {showReports && (
// //         <>
// //           <button onClick={() => setShowReports(false)}>✖ Close Report</button>
// //           <Reports />
// //         </>
// //       )}
// //       {!showReports && (
// //         <div className="table-container">
// //           <div
// //             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
// //             style={{ flex: selectedBooking ? "1" : "2" }}
// //           >
// //             <div>
// //               <div className="bookings-header-my">
// //                 <span
// //                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
// //                   onClick={() => handleSort("LeadACVLRecordID")}
// //                   style={{ cursor: "pointer" }}
// //                 >
// //                   ACVL LeadID
// //                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
// //                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// //                 </span>
// //                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// //                   (colKey) => {
// //                     const column = allColumns.find((c) => c.key === colKey);
// //                     const isSorted = sortConfig.key === colKey;
// //                     return column ? (
// //                       <span
// //                         key={colKey}
// //                         className="sortable-header"
// //                         onClick={() => handleSort(colKey)}
// //                         style={{ cursor: "pointer" }}
// //                       >
// //                         {column.label}
// //                         {!isDefaultSort && isSorted &&
// //                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
// //                       </span>
// //                     ) : null;
// //                   }
// //                 )}
// //                 <span2>
// //                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
// //                     <div>
// //                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
// //                     </div>
// //                     <div>
// //                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
// //                     </div>
// //                     <div>
// //                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
// //                     </div>
// //                     <div>
// //                       <Search
// //                         className="filter-icon"
// //                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
// //                         title="Advanced column search"
// //                       />
// //                     </div>
// //                   </div>
// //                 </span2>
// //                 {showFilter && (
// //                   <div className="filter-dropdown" ref={filterRef}>
// //                     {allColumns.map((col) => (
// //                       <label key={col.key}>
// //                         <input
// //                           type="checkbox"
// //                           value={col.key}
// //                           checked={selectedColumns.includes(col.key)}
// //                           onChange={handleColumnChange}
// //                           disabled={
// //                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
// //                           }
// //                         />
// //                         {col.label}
// //                       </label>
// //                     ))}
// //                   </div>
// //                 )}
// //               </div>
// //               {showAdvancedFilter && (
// //                 <div className="column-filter-row">
// //                   <span className="filter-input">
// //                     <input
// //                       placeholder="Lead ID"
// //                       value={columnFilters["LeadACVLRecordID"] || ""}
// //                       onChange={(e) =>
// //                         setColumnFilters({
// //                           ...columnFilters,
// //                           LeadACVLRecordID: e.target.value,
// //                         })
// //                       }
// //                     />
// //                   </span>
// //                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// //                     (colKey) => (
// //                       <span key={colKey} className="filter-input">
// //                         <input
// //                           placeholder={
// //                             allColumns.find((col) => col.key === colKey)?.label || colKey
// //                           }
// //                           value={columnFilters[colKey] || ""}
// //                           onChange={(e) =>
// //                             setColumnFilters({
// //                               ...columnFilters,
// //                               [colKey]: e.target.value,
// //                             })
// //                           }
// //                         />
// //                       </span>
// //                     )
// //                   )}
// //                   <span className="filter-icons-space" />
// //                 </div>
// //               )}
// //               {loading && <p>Loading...</p>}
// //               {error && <p className="error">{error}</p>}
// //               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
// //               {!loading &&
// //                 !error &&
// //                 sortedData.map((item, index) => {
// //                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
// //                   const categories = leadNotesData.latestByCategory;
// //                   let flags = [];
// //                   const now = new Date();
// //                   const todayStr = now.toLocaleString('en-CA', { 
// //                     timeZone: 'America/Toronto', 
// //                     year: 'numeric', 
// //                     month: '2-digit', 
// //                     day: '2-digit' 
// //                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
// //                   const isUnassignedToday =
// //                     (item.Status === null || item.Status === undefined) &&
// //                     item.Received_Date_EST &&
// //                     item.Received_Date_EST.split(' ')[0] === todayStr;
// //                   const isUnassignedall =
// //                     (item.Status === null || item.Status === undefined) &&
// //                     item.Received_Date_EST &&
// //                     item.Received_Date_EST.split(' ')[0] !== todayStr;
// //                   let isTodayFollowUp = false;

// //                   // Collect and process follow-up dates
// //                   const followUpDates = [];
                  
// //                   // Add follow-up date from notes (next follow-up category)
// //                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
// //                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
// //                     if (noteDate) {
// //                       followUpDates.push(noteDate);
// //                     }
// //                   }

// //                   // Add follow-up date from item.FollowUpDate
// //                   if (item.FollowUpDate) {
// //                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
// //                     if (itemDate && !followUpDates.includes(itemDate)) {
// //                       followUpDates.push(itemDate);
// //                     }
// //                   }

// //                   // Select the most relevant follow-up date
// //                   let selectedFollowUpDate = null;
// //                   if (followUpDates.length > 0) {
// //                     // Prioritize: today's date, then past date, then future date
// //                     const today = new Date(todayStr);
// //                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
// //                       const followUpDate = new Date(dateStr);
// //                       if (!selected) return dateStr;
// //                       const selectedDate = new Date(selected);
// //                       if (dateStr === todayStr) return dateStr; // Prioritize today's date
// //                       if (selected === todayStr) return selected;
// //                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
// //                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
// //                       return selected; // Keep first date if no priority
// //                     }, null);

// //                     if (selectedFollowUpDate) {
// //                       const followUpDate = new Date(selectedFollowUpDate);
// //                       isTodayFollowUp = selectedFollowUpDate === todayStr;
// //                       let color;
// //                       if (followUpDate < today && !isTodayFollowUp) {
// //                         color = "red"; // Past date
// //                       } else if (isTodayFollowUp) {
// //                         color = "green"; // Today
// //                       } else {
// //                         color = "gray"; // Future date
// //                       }
// //                       flags.push({ 
// //                         icon: Clock, 
// //                         color, 
// //                         title: `Follow-Up: ${selectedFollowUpDate}` 
// //                       });
// //                     }
// //                   }

// //                   // Process other categories
// //                   Object.values(categories).forEach((note) => {
// //                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
// //                       const category = note.Category?.toLowerCase() || "";
// //                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
// //                       if (category === "connection status") {
// //                         if (categoryDetails === "connected") {
// //                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
// //                         } else if (categoryDetails === "not connected") {
// //                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
// //                         }
// //                       } else if (category === "prospective") {
// //                         if (categoryDetails === "hot") {
// //                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
// //                         } else if (categoryDetails === "warm") {
// //                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
// //                         } else if (categoryDetails === "cold") {
// //                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
// //                         }
// //                       }
// //                     }
// //                   });

// //                   // Process Lead_Priority for left side icon
// //                   let priorityFlag = null;
// //                   if (item.Lead_Priority) {
// //                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
// //                     let color, title;
// //                     if (priority === "high") {
// //                       color = "red";
// //                       title = "High";
// //                     } else if (priority === "medium") {
// //                       color = "purple";
// //                       title = "Medium";
// //                     } else if (priority === "low") {
// //                       color = "green";
// //                       title = "Low";
// //                     }
// //                     if (color && title) {
// //                       priorityFlag = { icon: Circle, color, title };
// //                     }
// //                   }

// //                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
// //                   const orderedFlags = new Array(5).fill(null);
// //                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
// //                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
// //                   }
// //                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
// //                     if (item.Return_Outcome?.toLowerCase() === "approved") {
// //                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
// //                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
// //                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
// //                     } else {
// //                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
// //                     }
// //                   }
// //                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
// //                   if (prospectiveFlag) {
// //                     orderedFlags[2] = prospectiveFlag;
// //                   }
// //                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
// //                   if (connectionFlag) {
// //                     orderedFlags[3] = connectionFlag;
// //                   }
// //                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
// //                   if (followUpFlag) {
// //                     orderedFlags[4] = followUpFlag;
// //                   }

// //                   return (
// //                     <div
// //                       key={index}
// //                       className={`booking-item-my ${
// //                         selectedBooking === item ? "active-booking" : ""
// //                       } ${
// //                         item.Duplicate_Lead_Details &&
// //                         Object.keys(item.Duplicate_Lead_Details).length > 0
// //                           ? "duplicate-item"
// //                           : ""
// //                       } ${
// //                         item.Lead_Source_Status?.toLowerCase() === "return"
// //                           ? "returned-item"
// //                           : ""
// //                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
// //                       onClick={() => {
// //                         if (!selectedBooking) setWidth(700);
// //                         setSelectedBooking(item);
// //                       }}
// //                       style={{
// //                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
// //                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
// //                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
// //                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
// //                       }}
// //                     >
// //                       {priorityFlag && (
// //                         <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
// //                           <>
// //                             <priorityFlag.icon
// //                               className="icon"
// //                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
// //                               fill={priorityFlag.color}
// //                               title={priorityFlag.title}
// //                             />
// //                             <div className="custom-tooltip1">
// //                               {priorityFlag.title}
// //                             </div>
// //                           </>
// //                         </div>
// //                       )}
// //                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
// //                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
// //                         (colKey) => (
// //                           <span1 key={colKey}>
// //                             {colKey === "AssignedUserID"
// //                               ? userMap[item.AssignedUserID] || "N/A"
// //                               : colKey === "FollowUpDate"
// //                               ? formatFollowUpDate(item[colKey])
// //                               : item[colKey] || "N/A"}
// //                           </span1>
// //                         )
// //                       )}
// //                       <span2 style={{
// //                         display: "flex",
// //                         gap: "8px",
// //                         alignItems: "center",
// //                         justifyContent: "flex-end",
// //                         width: "120px",
// //                       }}>
// //                         {orderedFlags.map((flag, idx) => (
// //                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
// //                             {flag && (
// //                               <>
// //                                 <flag.icon
// //                                   className="icon"
// //                                   style={{ color: flag.color, width: "16px", height: "16px" }}
// //                                   title={flag.title}
// //                                 />
// //                                 <div className="custom-tooltip">
// //                                   {flag.title}
// //                                 </div>
// //                               </>
// //                             )}
// //                           </div>
// //                         ))}
// //                       </span2>
// //                     </div>
// //                   );
// //                 })}
// //             </div>
// //           </div>
// //           {selectedBooking && (
// //             <div className="lead-details-container" style={{ width: `${width}px` }}>
// //               <div className="resize-handle" onMouseDown={startResizing}></div>
// //               <LeadDetails
// //                 key={selectedBooking.LeadACVLRecordID}
// //                 booking={selectedBooking}
// //                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
// //                 onClose={() => setSelectedBooking(null)}
// //                 userDetails={userDetails}
// //                 accessToken={accessToken}
// //                 userMap={userMap}
// //                 updateLeadData={updateLeadData}
// //                 refetchNotes={refetchNotes}
// //               />
// //             </div>
// //           )}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Homepage;
// // changes after the header
// import React, { useState, useEffect, useRef } from "react";
// import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle } from "lucide-react";
// import LeadDetails from "./Leaddetails";
// import TimelineComponent from "./Header";
// import Reports from "./Reports";

// const allColumns = [
//   { key: "Sales_Agent", label: "Sales Agent" },
//   { key: "Customer_Name", label: "Lead Name" },
//   { key: "Move_Date", label: "Move Date" },
//   { key: "Status", label: "Estimate Status" },
//   { key: "OriginCity", label: "From Province" },
//   { key: "DestinationCity", label: "To Province" },
//   { key: "FollowUpDate", label: "Follow Up Date" },
//   { key: "Move_Size", label: "Move Size" },
//   { key: "Lead_Status", label: "Lead Status" },
//   { key: "Move_Type", label: "Move Type" },
//   { key: "Estimate_Amount", label: "Estimate Amount" },
//   { key: "From_Postcode", label: "From Postcode" },
//   { key: "To_Postcode", label: "To Postcode" },
//   { key: "Received_Date_EST", label: "Received Date EST" },
//   { key: "Banner", label: "Banner" },
//   { key: "Lead_Priority", label: "Lead Priority" },
//   { key: "Received_Time_IST", label: "Received Time IST" },
// ];

// const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
//   const [showReports, setShowReports] = useState(false);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [width, setWidth] = useState(350);
//   const [showFilter, setShowFilter] = useState(false);
//   const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
//   const [columnFilters, setColumnFilters] = useState({});
//   const [selectedColumns, setSelectedColumns] = useState(
//     allColumns.slice(0, 7).map((col) => col.key)
//   );
//   const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
//   const [isDefaultSort, setIsDefaultSort] = useState(false);
//   const filterRef = useRef(null);
//   const isResizing = useRef(false);
//   const [userMap, setUserMap] = useState({});
//   const [isGlobalSearch, setIsGlobalSearch] = useState(false);
//   const prevSelectedLeadId = useRef(null);
//   const [allNotes, setAllNotes] = useState([]);

//   const updateLeadData = (updatedBooking) => {
//     setData((prevData) =>
//       prevData.map((lead) =>
//         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
//           ? { ...lead, ...updatedBooking }
//           : lead
//       )
//     );
//     setFilteredData((prevFilteredData) =>
//       prevFilteredData.map((lead) =>
//         lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
//           ? { ...lead, ...updatedBooking }
//           : lead
//       )
//     );
//     if (
//       selectedBooking &&
//       selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
//     ) {
//       setSelectedBooking(updatedBooking);
//     }
//   };

//   const refetchNotes = () => {
//     fetchAllNotes();
//   };

//   const formatFollowUpDate = (date) => {
//     if (!date) return "N/A";
//     return date.replace("T", " ");
//   };

//   const handleDefaultSort = () => {
//     setSearchQuery("");
//     setColumnFilters({});
//     setIsGlobalSearch(false);
//     setIsDefaultSort(true);
//     setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
//     fetchLeads();
//   };

//   const updateUserpreference = async (headers) => {
//       try {
//         const payload = { Userpreference: { Header: headers } };
//         await fetch("https://salesjet-10097049716.catalystappsail.com/userdata", {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         });
//       } catch (err) {
//         console.error("Error updating preferences:", err);
//       }
//   };
  
//   const loadPreferences = () => {
//     try {
//       const stored = localStorage.getItem("Userpreference");
//       let headers;
//       if (stored) {
//         const parsed = JSON.parse(stored);
//         headers = parsed.Headers || null;
//       }
//       if (!headers || !Array.isArray(headers) || headers.length === 0) {
//         headers = allColumns.slice(0, 7).map((col) => col.label);
//         const prefs = { Headers: headers };
//         localStorage.setItem("Userpreference", JSON.stringify(prefs));
//         updateUserpreference(headers);
//       }
//       // Map labels to keys
//       const keys = headers
//         .map((label) => {
//           const col = allColumns.find((c) => c.label === label);
//           return col ? col.key : null;
//         })
//         .filter(Boolean);
//       setSelectedColumns(keys);
//     } catch (err) {
//       console.error(err);
//       // Fallback to default
//       const headers = allColumns.slice(0, 7).map((col) => col.label);
//       const prefs = { Headers: headers };
//       localStorage.setItem("Userpreference", JSON.stringify(prefs));
//       updateUserpreference(headers);
//       setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
//     }
//   };

//   useEffect(() => {
//     if (accessToken) {
//       loadPreferences();
//     }
//   }, [accessToken]);

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const response = await fetch(
//           "https://salesjet-10097049716.catalystappsail.com/userdata",
//           {
//             method: "GET",
//             headers: {
//               Authorization: `Bearer ${accessToken}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         if (!response.ok) throw new Error(`Error: ${response.status}`);
//         const result = await response.json();
//         const userMapping = result.data.reduce((acc, user) => {
//           acc[user.userId] = user.pseudoname;
//           return acc;
//         }, {});
//         setUserMap(userMapping);
//       } catch (err) {
//         console.error("Error fetching user data:", err.message);
//       }
//     };
//     fetchUserData();
//   }, [accessToken]);

//   const fetchLeads = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(
//         "https://salesjet-10097049716.catalystappsail.com/leadsdata",
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (!response.ok) throw new Error(`Error: ${response.status}`);
//       const result = await response.json();
//       const leads = Array.isArray(result.data) ? result.data : [];
//       setData(leads);
//       setFilteredData(leads);
//     } catch (err) {
//       setError(err.message);
//       console.error("Error fetching leads:", err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAllNotes = async () => {
//     try {
//       const response = await fetch(
//         "https://salesjet-10097049716.catalystappsail.com/allleadnotes",
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (!response.ok) throw new Error(`Error: ${response.status}`);
//       const result = await response.json();
//       setAllNotes(Array.isArray(result.data) ? result.data : []);
//     } catch (err) {
//       console.error("Error fetching all lead notes:", err.message);
//     }
//   };

//   useEffect(() => {
//     if (!isGlobalSearch) {
//       fetchLeads();
//       fetchAllNotes();
//     }
//   }, [accessToken, isGlobalSearch]);

//   useEffect(() => {
//     handleDefaultSort();
//   }, []);

//   useEffect(() => {
//     if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
//       prevSelectedLeadId.current = selectedLeadId;
//       setIsGlobalSearch(true);
//       setColumnFilters({});
//       handleGlobalSearch(selectedLeadId.toString());
//     }
//   }, [selectedLeadId]);

//   useEffect(() => {
//     if (selectedLeadId && filteredData.length > 0) {
//       const matchingLead = filteredData.find(
//         (lead) =>
//           lead.LeadACVLRecordID &&
//           lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
//       );
//       if (matchingLead) {
//         setSelectedBooking(matchingLead);
//         setWidth(700);
//       } else {
//         setSelectedBooking(null);
//       }
//     } else if (selectedLeadId && filteredData.length === 0) {
//       setSelectedBooking(null);
//     }
//   }, [filteredData, selectedLeadId]);

//   useEffect(() => {
//     if (isGlobalSearch) {
//       return;
//     }
//     let filtered = [...data];
//     if (searchQuery.trim()) {
//       const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//       filtered = filtered.filter((lead) =>
//         Object.entries(lead).some(([key, value]) => {
//           if (!value) return false;
//           const normalizedValue = value
//             .toString()
//             .replace(/[^a-zA-Z0-9]/g, "")
//             .toLowerCase();
//           return normalizedValue.includes(normalizedQuery);
//         })
//       );
//     }
//     Object.keys(columnFilters).forEach((key) => {
//       const rawFilter = columnFilters[key];
//       if (rawFilter) {
//         const trimmedRawFilter = rawFilter.trim();
//         const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//         const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
//         if (isNAFilter) {
//           filtered = filtered.filter((lead) => {
//             const value = lead[key];
//             return value === null || value === undefined || value === "" || value === "N/A";
//           });
//         } else if (normalizedFilter) {
//           filtered = filtered.filter((lead) => {
//             const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//             return value?.includes(normalizedFilter);
//           });
//         }
//       }
//     });
//     setFilteredData(filtered);
//   }, [data, searchQuery, columnFilters, isGlobalSearch]);

//   const handleSearchChange = (query) => {
//     setSearchQuery(query);
//     setIsGlobalSearch(false);
//     setColumnFilters({});
//   };

//   const handleGlobalSearch = async (query) => {
//     setLoading(true);
//     setIsDefaultSort(false);
//     setIsGlobalSearch(true);
//     try {
//       const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
//       const response = await fetch(
//         "https://salesjet-10097049716.catalystappsail.com/globalsearch",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ query: normalizedQuery }),
//         }
//       );
//       if (!response.ok) throw new Error(`Error: ${response.status}`);
//       const result = await response.json();
//       const leads = Array.isArray(result.data) ? result.data : [];
//       setFilteredData(leads);
//       setSearchQuery(query);
//       fetchAllNotes();
//     } catch (err) {
//       console.error("Global search error:", err.message);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSort = (key) => {
//     setIsDefaultSort(false);
//     setSortConfig((prev) =>
//       prev.key === key
//         ? {
//             key,
//             direction: prev.direction === "ascending" ? "descending" : "ascending",
//           }
//         : { key, direction: "ascending" }
//     );
//   };

//   const handleColumnChange = (event) => {
//     const value = event.target.value;
//     setSelectedColumns((prev) => {
//       let newSelected;
//       if (prev.includes(value)) {
//         newSelected = prev.filter((col) => col !== value);
//       } else {
//         newSelected = prev.length < 7 ? [...prev, value] : prev;
//       }
//       // Update localStorage and backend
//       const labels = newSelected.map((key) => {
//         const col = allColumns.find((c) => c.key === key);
//         return col ? col.label : "";
//       });
//       const prefs = { Headers: labels };
//       localStorage.setItem("Userpreference", JSON.stringify(prefs));
//       updateUserpreference(labels);
//       return newSelected;
//     });
//   };

//   const sortedData = React.useMemo(() => {
//     let sortableData = [...filteredData];
//     if (isDefaultSort) {
//       // Get current date in EST (America/Toronto)
//       const now = new Date();
//       const todayStr = now.toLocaleString('en-CA', { 
//         timeZone: 'America/Toronto', 
//         year: 'numeric', 
//         month: '2-digit', 
//         day: '2-digit' 
//       }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

//       // Custom sorting logic
//       sortableData.sort((a, b) => {
//         const isUnassignedA = a.Status === null || a.Status === undefined;
//         const isUnassignedB = b.Status === null || b.Status === undefined;
//         const timeA = a.Received_Date_EST;
//         const timeB = b.Received_Date_EST;
//         const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
//         const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

//         // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
//         if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
//           return -1;
//         }
//         if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
//           return 1;
//         }

//         // Step 2: Leads with FollowUpDate date as today (EST)
//         if (followUpA === todayStr && followUpB !== todayStr) return -1;
//         if (followUpB === todayStr && followUpA !== todayStr) return 1;

//         // Step 3: Sort by LeadACVLRecordID descending as fallback
//         const idA = Number(a.LeadACVLRecordID || 0);
//         const idB = Number(b.LeadACVLRecordID || 0);
//         return idB - idA;
//       });
//     } else if (sortConfig.key) {
//       sortableData.sort((a, b) => {
//         let aVal = a[sortConfig.key];
//         let bVal = b[sortConfig.key];
//         // Handle null or undefined values
//         if (aVal === undefined || aVal === null) return 1;
//         if (bVal === undefined || bVal === null) return -1;
//         // Handle LeadACVLRecordID specifically as a number
//         if (sortConfig.key === "LeadACVLRecordID") {
//           aVal = Number(aVal);
//           bVal = Number(bVal);
//           return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
//         }
//         // Handle date fields
//         const isDateField = [
//           "Move_Date",
//           "Received_Date_EST",
//           "Received_Time_IST",
//           "FollowUpDate",
//         ].includes(sortConfig.key);
//         if (isDateField) {
//           const dateA = new Date(aVal);
//           const dateB = new Date(bVal);
//           return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
//         }
//         // Handle string fields
//         if (typeof aVal === "string" && typeof bVal === "string") {
//           return sortConfig.direction === "ascending"
//             ? aVal.localeCompare(bVal)
//             : bVal.localeCompare(bVal);
//         }
//         // Handle numeric fields
//         return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
//       });
//     }
//     return sortableData;
//   }, [filteredData, sortConfig, isDefaultSort]);

//   const notesByLead = React.useMemo(() => {
//     const map = {};
//     allNotes.forEach((note) => {
//       const id = note.LeadACVLRecordID;
//       if (id) {
//         if (!map[id]) {
//           map[id] = { notes: [], latestByCategory: {} };
//         }
//         map[id].notes.push(note);
//       }
//     });
//     Object.keys(map).forEach((leadId) => {
//       map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
//       const categoryMap = {};
//       map[leadId].notes.forEach((note) => {
//         const category = note.Category?.toLowerCase() || "";
//         if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
//           categoryMap[category] = note;
//         }
//       });
//       map[leadId].latestByCategory = categoryMap;
//     });
//     return map;
//   }, [allNotes]);

//   const startResizing = (e) => {
//     isResizing.current = true;
//     document.addEventListener("mousemove", resize);
//     document.addEventListener("mouseup", stopResizing);
//   };

//   const resize = (e) => {
//     if (!isResizing.current) return;
//     const minWidth = 500;
//     const maxWidth = window.innerWidth * 0.7;
//     let newWidth = window.innerWidth - e.clientX;
//     if (newWidth >= minWidth && newWidth <= maxWidth) {
//       setWidth(newWidth);
//     }
//   };

//   const stopResizing = () => {
//     isResizing.current = false;
//     document.removeEventListener("mousemove", resize);
//     document.removeEventListener("mouseup", stopResizing);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (filterRef.current && !filterRef.current.contains(event.target)) {
//         setShowFilter(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const today = new Date().toISOString().split('T')[0];

//   return (
//     <div>
//       <>
//         <TimelineComponent
//           userDetails={userDetails}
//           accessToken={accessToken}
//           onSearchChange={handleSearchChange}
//           onGlobalSearch={handleGlobalSearch}
//           connectionStatus={connectionStatus}
//           onShowReports={() => setShowReports(true)}
//           onListView={() => setShowReports(false)}
//         />
//       </>
//       {showReports && (
//         <>
//           {/* <button onClick={() => setShowReports(false)}>✖ Close Report</button> */}
//           <Reports />
//         </>
//       )}
//       {!showReports && (
//         <div className="table-container">
//           <div
//             className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
//             style={{ flex: selectedBooking ? "1" : "2" }}
//           >
//             <div>
//               <div className="bookings-header-my">
//                 <span
//                   className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
//                   onClick={() => handleSort("LeadACVLRecordID")}
//                   style={{ cursor: "pointer" }}
//                 >
//                   ACVL LeadID
//                   {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
//                     (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
//                 </span>
//                 {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
//                   (colKey) => {
//                     const column = allColumns.find((c) => c.key === colKey);
//                     const isSorted = sortConfig.key === colKey;
//                     return column ? (
//                       <span
//                         key={colKey}
//                         className="sortable-header"
//                         onClick={() => handleSort(colKey)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         {column.label}
//                         {!isDefaultSort && isSorted &&
//                           (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
//                       </span>
//                     ) : null;
//                   }
//                 )}
//                 <span2>
//                   <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
//                     <div>
//                       <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
//                     </div>
//                     <div>
//                       <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
//                     </div>
//                     <div>
//                       <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
//                     </div>
//                     <div>
//                       <Search
//                         className="filter-icon"
//                         onClick={() => setShowAdvancedFilter((prev) => !prev)}
//                         title="Advanced column search"
//                       />
//                     </div>
//                   </div>
//                 </span2>
//                 {showFilter && (
//                   <div className="filter-dropdown" ref={filterRef}>
//                     {allColumns.map((col) => (
//                       <label key={col.key}>
//                         <input
//                           type="checkbox"
//                           value={col.key}
//                           checked={selectedColumns.includes(col.key)}
//                           onChange={handleColumnChange}
//                           disabled={
//                             !selectedColumns.includes(col.key) && selectedColumns.length >= 7
//                           }
//                         />
//                         {col.label}
//                       </label>
//                     ))}
//                   </div>
//                 )}
//               </div>
//               {showAdvancedFilter && (
//                 <div className="column-filter-row">
//                   <span className="filter-input">
//                     <input
//                       placeholder="Lead ID"
//                       value={columnFilters["LeadACVLRecordID"] || ""}
//                       onChange={(e) =>
//                         setColumnFilters({
//                           ...columnFilters,
//                           LeadACVLRecordID: e.target.value,
//                         })
//                       }
//                     />
//                   </span>
//                   {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
//                     (colKey) => (
//                       <span key={colKey} className="filter-input">
//                         <input
//                           placeholder={
//                             allColumns.find((col) => col.key === colKey)?.label || colKey
//                           }
//                           value={columnFilters[colKey] || ""}
//                           onChange={(e) =>
//                             setColumnFilters({
//                               ...columnFilters,
//                               [colKey]: e.target.value,
//                             })
//                           }
//                         />
//                       </span>
//                     )
//                   )}
//                   <span className="filter-icons-space" />
//                 </div>
//               )}
//               {loading && <p>Loading...</p>}
//               {error && <p className="error">{error}</p>}
//               {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
//               {!loading &&
//                 !error &&
//                 sortedData.map((item, index) => {
//                   const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
//                   const categories = leadNotesData.latestByCategory;
//                   let flags = [];
//                   const now = new Date();
//                   const todayStr = now.toLocaleString('en-CA', { 
//                     timeZone: 'America/Toronto', 
//                     year: 'numeric', 
//                     month: '2-digit', 
//                     day: '2-digit' 
//                   }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
//                   const isUnassignedToday =
//                     (item.Status === null || item.Status === undefined) &&
//                     item.Received_Date_EST &&
//                     item.Received_Date_EST.split(' ')[0] === todayStr;
//                   const isUnassignedall =
//                     (item.Status === null || item.Status === undefined) &&
//                     item.Received_Date_EST &&
//                     item.Received_Date_EST.split(' ')[0] !== todayStr;
//                   let isTodayFollowUp = false;

//                   // Collect and process follow-up dates
//                   const followUpDates = [];
                  
//                   // Add follow-up date from notes (next follow-up category)
//                   if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
//                     const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
//                     if (noteDate) {
//                       followUpDates.push(noteDate);
//                     }
//                   }

//                   // Add follow-up date from item.FollowUpDate
//                   if (item.FollowUpDate) {
//                     const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
//                     if (itemDate && !followUpDates.includes(itemDate)) {
//                       followUpDates.push(itemDate);
//                     }
//                   }

//                   // Select the most relevant follow-up date
//                   let selectedFollowUpDate = null;
//                   if (followUpDates.length > 0) {
//                     // Prioritize: today's date, then past date, then future date
//                     const today = new Date(todayStr);
//                     selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
//                       const followUpDate = new Date(dateStr);
//                       if (!selected) return dateStr;
//                       const selectedDate = new Date(selected);
//                       if (dateStr === todayStr) return dateStr; // Prioritize today's date
//                       if (selected === todayStr) return selected;
//                       if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
//                       if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
//                       return selected; // Keep first date if no priority
//                     }, null);

//                     if (selectedFollowUpDate) {
//                       const followUpDate = new Date(selectedFollowUpDate);
//                       isTodayFollowUp = selectedFollowUpDate === todayStr;
//                       let color;
//                       if (followUpDate < today && !isTodayFollowUp) {
//                         color = "red"; // Past date
//                       } else if (isTodayFollowUp) {
//                         color = "green"; // Today
//                       } else {
//                         color = "gray"; // Future date
//                       }
//                       flags.push({ 
//                         icon: Clock, 
//                         color, 
//                         title: `Follow-Up: ${selectedFollowUpDate}` 
//                       });
//                     }
//                   }

//                   // Process other categories
//                   Object.values(categories).forEach((note) => {
//                     if (note && note.Category?.toLowerCase() !== "next follow-up") {
//                       const category = note.Category?.toLowerCase() || "";
//                       const categoryDetails = note.Category_Details?.toLowerCase() || "";
//                       if (category === "connection status") {
//                         if (categoryDetails === "connected") {
//                           flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
//                         } else if (categoryDetails === "not connected") {
//                           flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
//                         }
//                       } else if (category === "prospective") {
//                         if (categoryDetails === "hot") {
//                           flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
//                         } else if (categoryDetails === "warm") {
//                           flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
//                         } else if (categoryDetails === "cold") {
//                           flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
//                         }
//                       }
//                     }
//                   });

//                   // Process Lead_Priority for left side icon
//                   let priorityFlag = null;
//                   if (item.Lead_Priority) {
//                     const priority = item.Lead_Priority.toString().toLowerCase().trim();
//                     let color, title;
//                     if (priority === "high") {
//                       color = "red";
//                       title = "High";
//                     } else if (priority === "medium") {
//                       color = "purple";
//                       title = "Medium";
//                     } else if (priority === "low") {
//                       color = "green";
//                       title = "Low";
//                     }
//                     if (color && title) {
//                       priorityFlag = { icon: Circle, color, title };
//                     }
//                   }

//                   // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
//                   const orderedFlags = new Array(5).fill(null);
//                   if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
//                     orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
//                   }
//                   if (item.Lead_Source_Status?.toLowerCase() === "return") {
//                     if (item.Return_Outcome?.toLowerCase() === "approved") {
//                       orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
//                     } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
//                       orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
//                     } else {
//                       orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
//                     }
//                   }
//                   const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
//                   if (prospectiveFlag) {
//                     orderedFlags[2] = prospectiveFlag;
//                   }
//                   const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
//                   if (connectionFlag) {
//                     orderedFlags[3] = connectionFlag;
//                   }
//                   const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
//                   if (followUpFlag) {
//                     orderedFlags[4] = followUpFlag;
//                   }

//                   return (
//                     <div
//                       key={index}
//                       className={`booking-item-my ${
//                         selectedBooking === item ? "active-booking" : ""
//                       } ${
//                         item.Duplicate_Lead_Details &&
//                         Object.keys(item.Duplicate_Lead_Details).length > 0
//                           ? "duplicate-item"
//                           : ""
//                       } ${
//                         item.Lead_Source_Status?.toLowerCase() === "return"
//                           ? "returned-item"
//                           : ""
//                       } ${isTodayFollowUp ? "follow-up-today" : ""}`}
//                       onClick={() => {
//                         if (!selectedBooking) setWidth(700);
//                         setSelectedBooking(item);
//                       }}
//                       style={{
//                         ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
//                         ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
//                         ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
//                         ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
//                       }}
//                     >
//                       {priorityFlag && (
//                         <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
//                           <>
//                             <priorityFlag.icon
//                               className="icon"
//                               style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
//                               fill={priorityFlag.color}
//                               title={priorityFlag.title}
//                             />
//                             <div className="custom-tooltip1">
//                               {priorityFlag.title}
//                             </div>
//                           </>
//                         </div>
//                       )}
//                       <span1>{item.LeadACVLRecordID || "N/A"}</span1>
//                       {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
//                         (colKey) => (
//                           <span1 key={colKey}>
//                             {colKey === "AssignedUserID"
//                               ? userMap[item.AssignedUserID] || "N/A"
//                               : colKey === "FollowUpDate"
//                               ? formatFollowUpDate(item[colKey])
//                               : item[colKey] || "N/A"}
//                           </span1>
//                         )
//                       )}
//                       <span2 style={{
//                         display: "flex",
//                         gap: "8px",
//                         alignItems: "center",
//                         justifyContent: "flex-end",
//                         width: "120px",
//                       }}>
//                         {orderedFlags.map((flag, idx) => (
//                           <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
//                             {flag && (
//                               <>
//                                 <flag.icon
//                                   className="icon"
//                                   style={{ color: flag.color, width: "16px", height: "16px" }}
//                                   title={flag.title}
//                                 />
//                                 <div className="custom-tooltip">
//                                   {flag.title}
//                                 </div>
//                               </>
//                             )}
//                           </div>
//                         ))}
//                       </span2>
//                     </div>
//                   );
//                 })}
//             </div>
//           </div>
//           {selectedBooking && (
//             <div className="lead-details-container" style={{ width: `${width}px` }}>
//               <div className="resize-handle" onMouseDown={startResizing}></div>
//               <LeadDetails
//                 key={selectedBooking.LeadACVLRecordID}
//                 booking={selectedBooking}
//                 notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
//                 onClose={() => setSelectedBooking(null)}
//                 userDetails={userDetails}
//                 accessToken={accessToken}
//                 userMap={userMap}
//                 updateLeadData={updateLeadData}
//                 refetchNotes={refetchNotes}
//               />
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Homepage;
import React, { useState, useEffect, useRef } from "react";
import { RefreshCcw, Filter, Search, Copy, ArrowUpRight, Flame, Snowflake, Thermometer, Phone, ArrowUpDown, Clock, AlertTriangle, Circle } from "lucide-react";
import LeadDetails from "./Leaddetails";
import TimelineComponent from "./Header";
import Reports from "./Reports";

const allColumns = [
  { key: "Sales_Agent", label: "Sales Agent" },
  { key: "Customer_Name", label: "Lead Name" },
  { key: "Move_Date", label: "Move Date" },
  { key: "Status", label: "Estimate Status" },
  { key: "OriginCity", label: "From Province" },
  { key: "DestinationCity", label: "To Province" },
  { key: "FollowUpDate", label: "Follow Up Date" },
  { key: "Move_Size", label: "Move Size" },
  { key: "Lead_Status", label: "Lead Status" },
  { key: "Move_Type", label: "Move Type" },
  { key: "Estimate_Amount", label: "Estimate Amount" },
  { key: "From_Postcode", label: "From Postcode" },
  { key: "To_Postcode", label: "To Postcode" },
  { key: "Received_Date_EST", label: "Received Date EST" },
  { key: "Banner", label: "Banner" },
  { key: "Lead_Priority", label: "Lead Priority" },
  { key: "Received_Time_IST", label: "Received Time IST" },
];

const Homepage = ({ accessToken, userDetails, connectionStatus, selectedLeadId }) => {
  const [showReports, setShowReports] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [width, setWidth] = useState(350);
  const [showFilter, setShowFilter] = useState(false);
  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);
  const [columnFilters, setColumnFilters] = useState({});
  const [selectedColumns, setSelectedColumns] = useState(
    allColumns.slice(0, 7).map((col) => col.key)
  );
  const [sortConfig, setSortConfig] = useState({ key: "LeadACVLRecordID", direction: "descending" });
  const [isDefaultSort, setIsDefaultSort] = useState(false);
  const filterRef = useRef(null);
  const isResizing = useRef(false);
  const [userMap, setUserMap] = useState({});
  const [isGlobalSearch, setIsGlobalSearch] = useState(false);
  const prevSelectedLeadId = useRef(null);
  const [allNotes, setAllNotes] = useState([]);

  const updateLeadData = (updatedBooking) => {
    setData((prevData) =>
      prevData.map((lead) =>
        lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
          ? { ...lead, ...updatedBooking }
          : lead
      )
    );
    setFilteredData((prevFilteredData) =>
      prevFilteredData.map((lead) =>
        lead.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
          ? { ...lead, ...updatedBooking }
          : lead
      )
    );
    if (
      selectedBooking &&
      selectedBooking.LeadACVLRecordID === updatedBooking.LeadACVLRecordID
    ) {
      setSelectedBooking(updatedBooking);
    }
  };

  const refetchNotes = () => {
    fetchAllNotes();
  };

  const formatFollowUpDate = (date) => {
    if (!date) return "N/A";
    return date.replace("T", " ");
  };

  const handleDefaultSort = () => {
    setSearchQuery("");
    setColumnFilters({});
    setIsGlobalSearch(false);
    setIsDefaultSort(true);
    setSortConfig({ key: "LeadACVLRecordID", direction: "descending" });
    fetchLeads();
  };

  const updateUserpreference = async (headers) => {
      try {
        const payload = { Userpreference: { Header: headers } };
        await fetch("https://salesjet-10097049716.catalystappsail.com/userdata", {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
      } catch (err) {
        console.error("Error updating preferences:", err);
      }
  };
  
  const loadPreferences = () => {
    try {
      const stored = localStorage.getItem("Userpreference");
      let headers;
      if (stored) {
        const parsed = JSON.parse(stored);
        headers = parsed.Headers || null;
      }
      if (!headers || !Array.isArray(headers) || headers.length === 0) {
        headers = allColumns.slice(0, 7).map((col) => col.label);
        const prefs = { Headers: headers };
        localStorage.setItem("Userpreference", JSON.stringify(prefs));
        updateUserpreference(headers);
      }
      // Map labels to keys
      const keys = headers
        .map((label) => {
          const col = allColumns.find((c) => c.label === label);
          return col ? col.key : null;
        })
        .filter(Boolean);
      setSelectedColumns(keys);
    } catch (err) {
      console.error(err);
      // Fallback to default
      const headers = allColumns.slice(0, 7).map((col) => col.label);
      const prefs = { Headers: headers };
      localStorage.setItem("Userpreference", JSON.stringify(prefs));
      updateUserpreference(headers);
      setSelectedColumns(allColumns.slice(0, 7).map((col) => col.key));
    }
  };

  useEffect(() => {
    if (accessToken) {
      loadPreferences();
    }
  }, [accessToken]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          "https://salesjet-10097049716.catalystappsail.com/userdata",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        const result = await response.json();
        const userMapping = result.data.reduce((acc, user) => {
          acc[user.userId] = user.pseudoname;
          return acc;
        }, {});
        setUserMap(userMapping);
      } catch (err) {
        console.error("Error fetching user data:", err.message);
      }
    };
    fetchUserData();
  }, [accessToken]);

  const fetchLeads = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        "https://salesjet-10097049716.catalystappsail.com/leadsdata",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const result = await response.json();
      const leads = Array.isArray(result.data) ? result.data : [];
      setData(leads);
      setFilteredData(leads);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching leads:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllNotes = async () => {
    try {
      const response = await fetch(
        "https://salesjet-10097049716.catalystappsail.com/allleadnotes",
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const result = await response.json();
      setAllNotes(Array.isArray(result.data) ? result.data : []);
    } catch (err) {
      console.error("Error fetching all lead notes:", err.message);
    }
  };

  useEffect(() => {
    if (!isGlobalSearch) {
      fetchLeads();
      fetchAllNotes();
    }
  }, [accessToken, isGlobalSearch]);

  useEffect(() => {
    handleDefaultSort();
  }, []);

  useEffect(() => {
    if (selectedLeadId && selectedLeadId !== prevSelectedLeadId.current) {
      prevSelectedLeadId.current = selectedLeadId;
      setIsGlobalSearch(true);
      setColumnFilters({});
      handleGlobalSearch(selectedLeadId.toString());
    }
  }, [selectedLeadId]);

  useEffect(() => {
    if (selectedLeadId && filteredData.length > 0) {
      const matchingLead = filteredData.find(
        (lead) =>
          lead.LeadACVLRecordID &&
          lead.LeadACVLRecordID.toString() === selectedLeadId.toString()
      );
      if (matchingLead) {
        setSelectedBooking(matchingLead);
        setWidth(700);
      } else {
        setSelectedBooking(null);
      }
    } else if (selectedLeadId && filteredData.length === 0) {
      setSelectedBooking(null);
    }
  }, [filteredData, selectedLeadId]);

  useEffect(() => {
    if (isGlobalSearch) {
      return;
    }
    let filtered = [...data];
    if (searchQuery.trim()) {
      const normalizedQuery = searchQuery.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
      filtered = filtered.filter((lead) =>
        Object.entries(lead).some(([key, value]) => {
          if (!value) return false;
          const normalizedValue = value
            .toString()
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();
          return normalizedValue.includes(normalizedQuery);
        })
      );
    }
    Object.keys(columnFilters).forEach((key) => {
      const rawFilter = columnFilters[key];
      if (rawFilter) {
        const trimmedRawFilter = rawFilter.trim();
        const normalizedFilter = trimmedRawFilter.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        const isNAFilter = trimmedRawFilter.toLowerCase() === "n/a";
        if (isNAFilter) {
          filtered = filtered.filter((lead) => {
            const value = lead[key];
            return value === null || value === undefined || value === "" || value === "N/A";
          });
        } else if (normalizedFilter) {
          filtered = filtered.filter((lead) => {
            const value = lead[key]?.toString().replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            return value?.includes(normalizedFilter);
          });
        }
      }
    });
    setFilteredData(filtered);
  }, [data, searchQuery, columnFilters, isGlobalSearch]);

  const handleSearchChange = (query) => {
    setSearchQuery(query);
    setIsGlobalSearch(false);
    setColumnFilters({});
  };

  const handleGlobalSearch = async (query) => {
    setLoading(true);
    setIsDefaultSort(false);
    setIsGlobalSearch(true);
    try {
      const normalizedQuery = query.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
      const response = await fetch(
        "https://salesjet-10097049716.catalystappsail.com/globalsearch",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ query: normalizedQuery }),
        }
      );
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const result = await response.json();
      const leads = Array.isArray(result.data) ? result.data : [];
      setFilteredData(leads);
      setSearchQuery(query);
      fetchAllNotes();
    } catch (err) {
      console.error("Global search error:", err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (key) => {
    setIsDefaultSort(false);
    setSortConfig((prev) =>
      prev.key === key
        ? {
            key,
            direction: prev.direction === "ascending" ? "descending" : "ascending",
          }
        : { key, direction: "ascending" }
    );
  };

  const handleColumnChange = (event) => {
    const value = event.target.value;
    setSelectedColumns((prev) => {
      let newSelected;
      if (prev.includes(value)) {
        newSelected = prev.filter((col) => col !== value);
      } else {
        newSelected = prev.length < 7 ? [...prev, value] : prev;
      }
      // Update localStorage and backend
      const labels = newSelected.map((key) => {
        const col = allColumns.find((c) => c.key === key);
        return col ? col.label : "";
      });
      const prefs = { Headers: labels };
      localStorage.setItem("Userpreference", JSON.stringify(prefs));
      updateUserpreference(labels);
      return newSelected;
    });
  };

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (isDefaultSort) {
      // Get current date in EST (America/Toronto)
      const now = new Date();
      const todayStr = now.toLocaleString('en-CA', { 
        timeZone: 'America/Toronto', 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
      }).split(',')[0].split('/').reverse().join('-'); // Formats to "YYYY-MM-DD"

      // Custom sorting logic
      sortableData.sort((a, b) => {
        const isUnassignedA = a.Status === null || a.Status === undefined;
        const isUnassignedB = b.Status === null || b.Status === undefined;
        const timeA = a.Received_Date_EST;
        const timeB = b.Received_Date_EST;
        const followUpA = a.FollowUpDate ? a.FollowUpDate.split('T')[0] : '';
        const followUpB = b.FollowUpDate ? b.FollowUpDate.split('T')[0] : '';

        // Step 1: Leads with Status as null/undefined and Received_Date_EST date as today (EST)
        if (isUnassignedA && timeA === todayStr && (!isUnassignedB || timeB !== todayStr)) {
          return -1;
        }
        if (isUnassignedB && timeB === todayStr && (!isUnassignedA || timeA !== todayStr)) {
          return 1;
        }

        // Step 2: Leads with FollowUpDate date as today (EST)
        if (followUpA === todayStr && followUpB !== todayStr) return -1;
        if (followUpB === todayStr && followUpA !== todayStr) return 1;

        // Step 3: Sort by LeadACVLRecordID descending as fallback
        const idA = Number(a.LeadACVLRecordID || 0);
        const idB = Number(b.LeadACVLRecordID || 0);
        return idB - idA;
      });
    } else if (sortConfig.key) {
      sortableData.sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];
        // Handle null or undefined values
        if (aVal === undefined || aVal === null) return 1;
        if (bVal === undefined || bVal === null) return -1;
        // Handle LeadACVLRecordID specifically as a number
        if (sortConfig.key === "LeadACVLRecordID") {
          aVal = Number(aVal);
          bVal = Number(bVal);
          return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
        }
        // Handle date fields
        const isDateField = [
          "Move_Date",
          "Received_Date_EST",
          "Received_Time_IST",
          "FollowUpDate",
        ].includes(sortConfig.key);
        if (isDateField) {
          const dateA = new Date(aVal);
          const dateB = new Date(bVal);
          return sortConfig.direction === "ascending" ? dateA - dateB : dateB - dateA;
        }
        // Handle string fields
        if (typeof aVal === "string" && typeof bVal === "string") {
          return sortConfig.direction === "ascending"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(bVal);
        }
        // Handle numeric fields
        return sortConfig.direction === "ascending" ? aVal - bVal : bVal - aVal;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, isDefaultSort]);

  const notesByLead = React.useMemo(() => {
    const map = {};
    allNotes.forEach((note) => {
      const id = note.LeadACVLRecordID;
      if (id) {
        if (!map[id]) {
          map[id] = { notes: [], latestByCategory: {} };
        }
        map[id].notes.push(note);
      }
    });
    Object.keys(map).forEach((leadId) => {
      map[leadId].notes.sort((a, b) => new Date(b.NotesTimeStamp) - new Date(a.NotesTimeStamp));
      const categoryMap = {};
      map[leadId].notes.forEach((note) => {
        const category = note.Category?.toLowerCase() || "";
        if (!categoryMap[category] || new Date(note.NotesTimeStamp) > new Date(categoryMap[category].NotesTimeStamp)) {
          categoryMap[category] = note;
        }
      });
      map[leadId].latestByCategory = categoryMap;
    });
    return map;
  }, [allNotes]);

  const startResizing = (e) => {
    isResizing.current = true;
    document.addEventListener("mousemove", resize);
    document.addEventListener("mouseup", stopResizing);
  };

  const resize = (e) => {
    if (!isResizing.current) return;
    const minWidth = 500;
    const maxWidth = window.innerWidth * 0.7;
    let newWidth = window.innerWidth - e.clientX;
    if (newWidth >= minWidth && newWidth <= maxWidth) {
      setWidth(newWidth);
    }
  };

  const stopResizing = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", resize);
    document.removeEventListener("mouseup", stopResizing);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const today = new Date().toISOString().split('T')[0];

  return (
    <div>
      <>
        <TimelineComponent
          userDetails={userDetails}
          accessToken={accessToken}
          onSearchChange={handleSearchChange}
          onGlobalSearch={handleGlobalSearch}
          connectionStatus={connectionStatus}
          onShowReports={() => setShowReports(true)}
          onListView={() => setShowReports(false)}
        />
      </>
      {showReports && (
        <>
          {/* <button onClick={() => setShowReports(false)}>✖ Close Report</button> */}
          <Reports />
        </>
      )}
      {!showReports && (
        <div className="table-container">
          <div
            className={`bookings-list-my ${selectedBooking ? "shrunk" : ""}`}
            style={{ flex: selectedBooking ? "1" : "2" }}
          >
            <div>
              <div className="bookings-header-my">
                <span
                  className={`sortable-header ${isDefaultSort ? "sorted-header" : ""}`}
                  onClick={() => handleSort("LeadACVLRecordID")}
                  style={{ cursor: "pointer" }}
                >
                  ACVL LeadID
                  {!isDefaultSort && sortConfig.key === "LeadACVLRecordID" &&
                    (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
                </span>
                {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
                  (colKey) => {
                    const column = allColumns.find((c) => c.key === colKey);
                    const isSorted = sortConfig.key === colKey;
                    return column ? (
                      <span
                        key={colKey}
                        className="sortable-header"
                        onClick={() => handleSort(colKey)}
                        style={{ cursor: "pointer" }}
                      >
                        {column.label}
                        {!isDefaultSort && isSorted &&
                          (sortConfig.direction === "ascending" ? " ▲" : " ▼")}
                      </span>
                    ) : null;
                  }
                )}
                <span2>
                  <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                    <div>
                      <RefreshCcw className="filter-icon" onClick={() => fetchLeads()} />
                    </div>
                    <div>
                      <ArrowUpDown className={`filter-icon ${isDefaultSort ? "sorted-icon" : ""}`} onClick={handleDefaultSort} title="Default Sort" />
                    </div>
                    <div>
                      <Filter className="filter-icon" onClick={() => setShowFilter(!showFilter)} />
                    </div>
                    <div>
                      <Search
                        className="filter-icon"
                        onClick={() => setShowAdvancedFilter((prev) => !prev)}
                        title="Advanced column search"
                      />
                    </div>
                  </div>
                </span2>
                {showFilter && (
                  <div className="filter-dropdown" ref={filterRef}>
                    {allColumns.map((col) => (
                      <label key={col.key}>
                        <input
                          type="checkbox"
                          value={col.key}
                          checked={selectedColumns.includes(col.key)}
                          onChange={handleColumnChange}
                          disabled={
                            !selectedColumns.includes(col.key) && selectedColumns.length >= 7
                          }
                        />
                        {col.label}
                      </label>
                    ))}
                  </div>
                )}
              </div>
              {showAdvancedFilter && (
                <div className="column-filter-row">
                  <span className="filter-input">
                    <input
                      placeholder="Lead ID"
                      value={columnFilters["LeadACVLRecordID"] || ""}
                      onChange={(e) =>
                        setColumnFilters({
                          ...columnFilters,
                          LeadACVLRecordID: e.target.value,
                        })
                      }
                    />
                  </span>
                  {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
                    (colKey) => (
                      <span key={colKey} className="filter-input">
                        <input
                          placeholder={
                            allColumns.find((col) => col.key === colKey)?.label || colKey
                          }
                          value={columnFilters[colKey] || ""}
                          onChange={(e) =>
                            setColumnFilters({
                              ...columnFilters,
                              [colKey]: e.target.value,
                            })
                          }
                        />
                      </span>
                    )
                  )}
                  <span className="filter-icons-space" />
                </div>
              )}
              {loading && <p>Loading...</p>}
              {error && <p className="error">{error}</p>}
              {!loading && !error && sortedData.length === 0 && <p>No leads found.</p>}
              {!loading &&
                !error &&
                sortedData.map((item, index) => {
                  const leadNotesData = notesByLead[item.LeadACVLRecordID] || { latestByCategory: {} };
                  const categories = leadNotesData.latestByCategory;
                  let flags = [];
                  const now = new Date();
                  const todayStr = now.toLocaleString('en-CA', { 
                    timeZone: 'America/Toronto', 
                    year: 'numeric', 
                    month: '2-digit', 
                    day: '2-digit' 
                  }).split(',')[0].split('/').reverse().join('-'); // Format: YYYY-MM-DD
                  const isUnassignedToday =
                    (item.Status === null || item.Status === undefined) &&
                    item.Received_Date_EST &&
                    item.Received_Date_EST.split(' ')[0] === todayStr;
                  const isUnassignedall =
                    (item.Status === null || item.Status === undefined) &&
                    item.Received_Date_EST &&
                    item.Received_Date_EST.split(' ')[0] !== todayStr;
                  let isTodayFollowUp = false;

                  // Collect and process follow-up dates
                  const followUpDates = [];
                  
                  // Add follow-up date from notes (next follow-up category)
                  if (categories["next follow-up"] && categories["next follow-up"].Category_Details) {
                    const noteDate = categories["next follow-up"].Category_Details.split('T')[0]; // Ensure YYYY-MM-DD
                    if (noteDate) {
                      followUpDates.push(noteDate);
                    }
                  }

                  // Add follow-up date from item.FollowUpDate
                  if (item.FollowUpDate) {
                    const itemDate = item.FollowUpDate.split('T')[0]; // Ensure YYYY-MM-DD
                    if (itemDate && !followUpDates.includes(itemDate)) {
                      followUpDates.push(itemDate);
                    }
                  }

                  // Select the most relevant follow-up date
                  let selectedFollowUpDate = null;
                  if (followUpDates.length > 0) {
                    // Prioritize: today's date, then past date, then future date
                    const today = new Date(todayStr);
                    selectedFollowUpDate = followUpDates.reduce((selected, dateStr) => {
                      const followUpDate = new Date(dateStr);
                      if (!selected) return dateStr;
                      const selectedDate = new Date(selected);
                      if (dateStr === todayStr) return dateStr; // Prioritize today's date
                      if (selected === todayStr) return selected;
                      if (followUpDate < today && selectedDate >= today) return dateStr; // Prefer past over future
                      if (followUpDate >= today && selectedDate < today) return selected; // Prefer future over past
                      return selected; // Keep first date if no priority
                    }, null);

                    if (selectedFollowUpDate) {
                      const followUpDate = new Date(selectedFollowUpDate);
                      isTodayFollowUp = selectedFollowUpDate === todayStr;
                      let color;
                      if (followUpDate < today && !isTodayFollowUp) {
                        color = "red"; // Past date
                      } else if (isTodayFollowUp) {
                        color = "green"; // Today
                      } else {
                        color = "gray"; // Future date
                      }
                      flags.push({ 
                        icon: Clock, 
                        color, 
                        title: `Follow-Up: ${selectedFollowUpDate}` 
                      });
                    }
                  }

                  // Process other categories
                  Object.values(categories).forEach((note) => {
                    if (note && note.Category?.toLowerCase() !== "next follow-up") {
                      const category = note.Category?.toLowerCase() || "";
                      const categoryDetails = note.Category_Details?.toLowerCase() || "";
                      if (category === "connection status") {
                        if (categoryDetails === "connected") {
                          flags.push({ icon: Phone, color: "green", title: "Connection: Connected" });
                        } else if (categoryDetails === "not connected") {
                          flags.push({ icon: Phone, color: "red", title: "Connection: Not Connected" });
                        }
                      } else if (category === "prospective") {
                        if (categoryDetails === "hot") {
                          flags.push({ icon: Flame, color: "red", title: "Prospective: Hot" });
                        } else if (categoryDetails === "warm") {
                          flags.push({ icon: Thermometer, color: "orange", title: "Prospective: Warm" });
                        } else if (categoryDetails === "cold") {
                          flags.push({ icon: Snowflake, color: "blue", title: "Prospective: Cold" });
                        }
                      }
                    }
                  });

                  // Process Lead_Priority for left side icon
                  let priorityFlag = null;
                  if (item.Lead_Priority) {
                    const priority = item.Lead_Priority.toString().toLowerCase().trim();
                    let color, title;
                    if (priority === "high") {
                      color = "red";
                      title = "High";
                    } else if (priority === "medium") {
                      color = "purple";
                      title = "Medium";
                    } else if (priority === "low") {
                      color = "green";
                      title = "Low";
                    }
                    if (color && title) {
                      priorityFlag = { icon: Circle, color, title };
                    }
                  }

                  // Sort flags to ensure order: Duplicate, Return Status, Prospective, Connection Status, Follow-Up
                  const orderedFlags = new Array(5).fill(null);
                  if (item.Duplicate_Lead_Details && Object.keys(item.Duplicate_Lead_Details).length > 0) {
                    orderedFlags[0] = { icon: Copy, color: "black", title: "Duplicate" };
                  }
                  if (item.Lead_Source_Status?.toLowerCase() === "return") {
                    if (item.Return_Outcome?.toLowerCase() === "approved") {
                      orderedFlags[1] = { icon: ArrowUpRight, color: "green", title: "Return: Approved" };
                    } else if (item.Return_Outcome?.toLowerCase() === "rejected") {
                      orderedFlags[1] = { icon: ArrowUpRight, color: "red", title: "Return: Rejected" };
                    } else {
                      orderedFlags[1] = { icon: ArrowUpRight, color: "black", title: "Return" };
                    }
                  }
                  const prospectiveFlag = flags.find(f => f.title.startsWith("Prospective:"));
                  if (prospectiveFlag) {
                    orderedFlags[2] = prospectiveFlag;
                  }
                  const connectionFlag = flags.find(f => f.title.startsWith("Connection:"));
                  if (connectionFlag) {
                    orderedFlags[3] = connectionFlag;
                  }
                  const followUpFlag = flags.find(f => f.title.startsWith("Follow-Up:"));
                  if (followUpFlag) {
                    orderedFlags[4] = followUpFlag;
                  }

                  return (
                    <div
                      key={index}
                      className={`booking-item-my ${
                        selectedBooking === item ? "active-booking" : ""
                      } ${
                        item.Duplicate_Lead_Details &&
                        Object.keys(item.Duplicate_Lead_Details).length > 0
                          ? "duplicate-item"
                          : ""
                      } ${
                        item.Lead_Source_Status?.toLowerCase() === "return"
                          ? "returned-item"
                          : ""
                      } ${isTodayFollowUp ? "follow-up-today" : ""}`}
                      onClick={() => {
                        if (!selectedBooking) setWidth(700);
                        setSelectedBooking(item);
                      }}
                      style={{
                        ...(isUnassignedToday || isTodayFollowUp ? { backgroundColor: "#e8b3b3" } : {}),
                        ...(isUnassignedToday ? { border: "2px solid #803394" } : {}),
                        ...(isUnassignedall ? { backgroundColor: "#f0e68c" } : {}),
                        ...(selectedBooking === item ? { backgroundColor: "#d2d5d8" } : {}),
                      }}
                    >
                      <div style={{ width: "18px", textAlign: "center", position: "relative" }}>
                        {priorityFlag && (
                          <>
                            <priorityFlag.icon
                              className="icon"
                              style={{ color: priorityFlag.color, width: "14px", height: "14px" }}
                              fill={priorityFlag.color}
                              title={priorityFlag.title}
                            />
                            <div className="custom-tooltip1">
                              {priorityFlag.title}
                            </div>
                          </>
                        )}
                      </div>
                      <span1>{item.LeadACVLRecordID || "N/A"}</span1>
                      {(selectedBooking ? selectedColumns.slice(0, 3) : selectedColumns).map(
                        (colKey) => (
                          <span1 key={colKey}>
                            {colKey === "AssignedUserID"
                              ? userMap[item.AssignedUserID] || "N/A"
                              : colKey === "FollowUpDate"
                              ? formatFollowUpDate(item[colKey])
                              : item[colKey] || "N/A"}
                          </span1>
                        )
                      )}
                      <span2 style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        width: "120px",
                      }}>
                        {orderedFlags.map((flag, idx) => (
                          <div key={idx} style={{ width: "20px", textAlign: "center", position: "relative" }}>
                            {flag && (
                              <>
                                <flag.icon
                                  className="icon"
                                  style={{ color: flag.color, width: "16px", height: "16px" }}
                                  title={flag.title}
                                />
                                <div className="custom-tooltip">
                                  {flag.title}
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                      </span2>
                    </div>
                  );
                })}
            </div>
          </div>
          {selectedBooking && (
            <div className="lead-details-container" style={{ width: `${width}px` }}>
              <div className="resize-handle" onMouseDown={startResizing}></div>
              <LeadDetails
                key={selectedBooking.LeadACVLRecordID}
                booking={selectedBooking}
                notes={notesByLead[selectedBooking.LeadACVLRecordID]?.notes || []}
                onClose={() => setSelectedBooking(null)}
                userDetails={userDetails}
                accessToken={accessToken}
                userMap={userMap}
                updateLeadData={updateLeadData}
                refetchNotes={refetchNotes}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Homepage;